/* eslint-disable */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.5
// Generated from `Act2020AllStarServant.jce'
// **********************************************************************

var HUYA = HUYA || {};


HUYA.EGender = 
{
    MALE: 0,
    FEMALE: 1
};


HUYA.BulletBorderGroundFormat = function()
{
    this.iEnableUse = 0;
    this.iBorderThickness = 0;
    this.iBorderColour = -1;
    this.iBorderDiaphaneity = 100;
    this.iGroundColour = -1;
    this.iGroundColourDiaphaneity = 100;
    this.sAvatarDecorationUrl = "";
    this.iFontColor = -1;
    this.iTerminalFlag = -1;
};
HUYA.BulletBorderGroundFormat.prototype._clone = function () { return new HUYA.BulletBorderGroundFormat(); }
HUYA.BulletBorderGroundFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BulletBorderGroundFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BulletBorderGroundFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iEnableUse);
    os.writeInt32(1, this.iBorderThickness);
    os.writeInt32(2, this.iBorderColour);
    os.writeInt32(3, this.iBorderDiaphaneity);
    os.writeInt32(4, this.iGroundColour);
    os.writeInt32(5, this.iGroundColourDiaphaneity);
    os.writeString(6, this.sAvatarDecorationUrl);
    os.writeInt32(7, this.iFontColor);
    os.writeInt32(8, this.iTerminalFlag);
};

HUYA.BulletBorderGroundFormat.prototype.readFrom = function (is)
{
    this.iEnableUse= is.readInt32(0, false, this.iEnableUse);
    this.iBorderThickness= is.readInt32(1, false, this.iBorderThickness);
    this.iBorderColour= is.readInt32(2, false, this.iBorderColour);
    this.iBorderDiaphaneity= is.readInt32(3, false, this.iBorderDiaphaneity);
    this.iGroundColour= is.readInt32(4, false, this.iGroundColour);
    this.iGroundColourDiaphaneity= is.readInt32(5, false, this.iGroundColourDiaphaneity);
    this.sAvatarDecorationUrl= is.readString(6, false, this.sAvatarDecorationUrl);
    this.iFontColor= is.readInt32(7, false, this.iFontColor);
    this.iTerminalFlag= is.readInt32(8, false, this.iTerminalFlag);
};

HUYA.FaithPresenter = function()
{
    this.lPid = 0;
    this.sLogo = "";
};
HUYA.FaithPresenter.prototype._clone = function () { return new HUYA.FaithPresenter(); }
HUYA.FaithPresenter.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FaithPresenter.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FaithPresenter.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sLogo);
};

HUYA.FaithPresenter.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sLogo= is.readString(1, false, this.sLogo);
};

HUYA.LiveAttributeInfo = function()
{
    this.vData = new Taf.BinBuffer();
    this.lTimespan = 0;
    this.lExpTimeMs = 0;
};
HUYA.LiveAttributeInfo.prototype._clone = function () { return new HUYA.LiveAttributeInfo(); }
HUYA.LiveAttributeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveAttributeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveAttributeInfo.prototype.writeTo = function (os)
{
    os.writeBytes(0, this.vData);
    os.writeInt64(1, this.lTimespan);
    os.writeInt64(2, this.lExpTimeMs);
};

HUYA.LiveAttributeInfo.prototype.readFrom = function (is)
{
    this.vData= is.readBytes(0, false, this.vData);
    this.lTimespan= is.readInt64(1, false, this.lTimespan);
    this.lExpTimeMs= is.readInt64(2, false, this.lExpTimeMs);
};

HUYA.GameLiveTag = function()
{
    this.iTagId = 0;
    this.sTagName = "";
    this.bIsShow = true;
    this.iBindingGameId = 0;
    this.iShowType = 0;
};
HUYA.GameLiveTag.prototype._clone = function () { return new HUYA.GameLiveTag(); }
HUYA.GameLiveTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTagId);
    os.writeString(1, this.sTagName);
    os.writeBoolean(2, this.bIsShow);
    os.writeInt32(3, this.iBindingGameId);
    os.writeInt32(4, this.iShowType);
};

HUYA.GameLiveTag.prototype.readFrom = function (is)
{
    this.iTagId= is.readInt32(0, false, this.iTagId);
    this.sTagName= is.readString(1, false, this.sTagName);
    this.bIsShow= is.readBoolean(2, false, this.bIsShow);
    this.iBindingGameId= is.readInt32(3, false, this.iBindingGameId);
    this.iShowType= is.readInt32(4, false, this.iShowType);
};

HUYA.NoblePetAttr = function()
{
    this.iPetId = 0;
    this.sPetName = "";
    this.sPetAction = "";
    this.iFrame = 0;
    this.iBeginTime = 0;
    this.iEndTime = 0;
};
HUYA.NoblePetAttr.prototype._clone = function () { return new HUYA.NoblePetAttr(); }
HUYA.NoblePetAttr.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NoblePetAttr.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NoblePetAttr.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iPetId);
    os.writeString(1, this.sPetName);
    os.writeString(2, this.sPetAction);
    os.writeInt32(3, this.iFrame);
    os.writeInt32(4, this.iBeginTime);
    os.writeInt32(5, this.iEndTime);
};

HUYA.NoblePetAttr.prototype.readFrom = function (is)
{
    this.iPetId= is.readInt32(0, false, this.iPetId);
    this.sPetName= is.readString(1, false, this.sPetName);
    this.sPetAction= is.readString(2, false, this.sPetAction);
    this.iFrame= is.readInt32(3, false, this.iFrame);
    this.iBeginTime= is.readInt32(4, false, this.iBeginTime);
    this.iEndTime= is.readInt32(5, false, this.iEndTime);
};

HUYA.NobleLevelAttr = function()
{
    this.iAttrType = 0;
    this.lValidDate = 0;
    this.iAttrStatus = 0;
    this.iProgress = 0;
    this.iTask = 0;
    this.iRemainDays = 0;
    this.sReserve = "";
};
HUYA.NobleLevelAttr.prototype._clone = function () { return new HUYA.NobleLevelAttr(); }
HUYA.NobleLevelAttr.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleLevelAttr.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleLevelAttr.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAttrType);
    os.writeInt64(1, this.lValidDate);
    os.writeInt32(2, this.iAttrStatus);
    os.writeInt32(3, this.iProgress);
    os.writeInt32(4, this.iTask);
    os.writeInt32(5, this.iRemainDays);
    os.writeString(6, this.sReserve);
};

HUYA.NobleLevelAttr.prototype.readFrom = function (is)
{
    this.iAttrType= is.readInt32(0, false, this.iAttrType);
    this.lValidDate= is.readInt64(1, false, this.lValidDate);
    this.iAttrStatus= is.readInt32(2, false, this.iAttrStatus);
    this.iProgress= is.readInt32(3, false, this.iProgress);
    this.iTask= is.readInt32(4, false, this.iTask);
    this.iRemainDays= is.readInt32(5, false, this.iRemainDays);
    this.sReserve= is.readString(6, false, this.sReserve);
};

HUYA.NobleLevelInfo = function()
{
    this.iNobleLevel = 0;
    this.iAttrType = 0;
};
HUYA.NobleLevelInfo.prototype._clone = function () { return new HUYA.NobleLevelInfo(); }
HUYA.NobleLevelInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleLevelInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleLevelInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iNobleLevel);
    os.writeInt32(1, this.iAttrType);
};

HUYA.NobleLevelInfo.prototype.readFrom = function (is)
{
    this.iNobleLevel= is.readInt32(0, false, this.iNobleLevel);
    this.iAttrType= is.readInt32(1, false, this.iAttrType);
};

HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};

HUYA.UidNickName = function()
{
    this.lUid = 0;
    this.sNickName = "";
};
HUYA.UidNickName.prototype._clone = function () { return new HUYA.UidNickName(); }
HUYA.UidNickName.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UidNickName.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UidNickName.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
};

HUYA.UidNickName.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
};

HUYA.MessageTagInfo = function()
{
    this.iAppId = 0;
    this.sTag = "";
};
HUYA.MessageTagInfo.prototype._clone = function () { return new HUYA.MessageTagInfo(); }
HUYA.MessageTagInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MessageTagInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MessageTagInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAppId);
    os.writeString(1, this.sTag);
};

HUYA.MessageTagInfo.prototype.readFrom = function (is)
{
    this.iAppId= is.readInt32(0, false, this.iAppId);
    this.sTag= is.readString(1, false, this.sTag);
};

HUYA.ContentFormat = function()
{
    this.iFontColor = -1;
    this.iFontSize = 4;
    this.iPopupStyle = 0;
    this.iNickNameFontColor = -1;
    this.iDarkFontColor = -1;
    this.iDarkNickNameFontColor = -1;
};
HUYA.ContentFormat.prototype._clone = function () { return new HUYA.ContentFormat(); }
HUYA.ContentFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ContentFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ContentFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFontColor);
    os.writeInt32(1, this.iFontSize);
    os.writeInt32(2, this.iPopupStyle);
    os.writeInt32(3, this.iNickNameFontColor);
    os.writeInt32(4, this.iDarkFontColor);
    os.writeInt32(5, this.iDarkNickNameFontColor);
};

HUYA.ContentFormat.prototype.readFrom = function (is)
{
    this.iFontColor= is.readInt32(0, false, this.iFontColor);
    this.iFontSize= is.readInt32(1, false, this.iFontSize);
    this.iPopupStyle= is.readInt32(2, false, this.iPopupStyle);
    this.iNickNameFontColor= is.readInt32(3, false, this.iNickNameFontColor);
    this.iDarkFontColor= is.readInt32(4, false, this.iDarkFontColor);
    this.iDarkNickNameFontColor= is.readInt32(5, false, this.iDarkNickNameFontColor);
};

HUYA.BulletFormat = function()
{
    this.iFontColor = -1;
    this.iFontSize = 4;
    this.iTextSpeed = 0;
    this.iTransitionType = 1;
    this.iPopupStyle = 0;
    this.tBorderGroundFormat = new HUYA.BulletBorderGroundFormat();
    this.vGraduatedColor = new Taf.Vector(new Taf.INT32());
    this.iAvatarFlag = 0;
    this.iAvatarTerminalFlag = -1;
};
HUYA.BulletFormat.prototype._clone = function () { return new HUYA.BulletFormat(); }
HUYA.BulletFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BulletFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BulletFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFontColor);
    os.writeInt32(1, this.iFontSize);
    os.writeInt32(2, this.iTextSpeed);
    os.writeInt32(3, this.iTransitionType);
    os.writeInt32(4, this.iPopupStyle);
    os.writeStruct(5, this.tBorderGroundFormat);
    os.writeVector(6, this.vGraduatedColor);
    os.writeInt32(7, this.iAvatarFlag);
    os.writeInt32(8, this.iAvatarTerminalFlag);
};

HUYA.BulletFormat.prototype.readFrom = function (is)
{
    this.iFontColor= is.readInt32(0, false, this.iFontColor);
    this.iFontSize= is.readInt32(1, false, this.iFontSize);
    this.iTextSpeed= is.readInt32(2, false, this.iTextSpeed);
    this.iTransitionType= is.readInt32(3, false, this.iTransitionType);
    this.iPopupStyle= is.readInt32(4, false, this.iPopupStyle);
    this.tBorderGroundFormat= is.readStruct(5, false, this.tBorderGroundFormat);
    this.vGraduatedColor= is.readVector(6, false, this.vGraduatedColor);
    this.iAvatarFlag= is.readInt32(7, false, this.iAvatarFlag);
    this.iAvatarTerminalFlag= is.readInt32(8, false, this.iAvatarTerminalFlag);
};

HUYA.SuperFansInfo = function()
{
    this.lSFExpiredTS = 0;
    this.iSFFlag = 0;
    this.lSFAnnualTS = 0;
};
HUYA.SuperFansInfo.prototype._clone = function () { return new HUYA.SuperFansInfo(); }
HUYA.SuperFansInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SuperFansInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SuperFansInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lSFExpiredTS);
    os.writeInt32(1, this.iSFFlag);
    os.writeInt64(2, this.lSFAnnualTS);
};

HUYA.SuperFansInfo.prototype.readFrom = function (is)
{
    this.lSFExpiredTS= is.readInt64(0, false, this.lSFExpiredTS);
    this.iSFFlag= is.readInt32(1, false, this.iSFFlag);
    this.lSFAnnualTS= is.readInt64(2, false, this.lSFAnnualTS);
};

HUYA.PresenterChannelInfo = function()
{
    this.lYYId = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iSourceType = 0;
    this.iScreenType = 0;
    this.lUid = 0;
    this.iGameId = 0;
    this.iRoomId = 0;
};
HUYA.PresenterChannelInfo.prototype._clone = function () { return new HUYA.PresenterChannelInfo(); }
HUYA.PresenterChannelInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterChannelInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterChannelInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lYYId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt32(4, this.iSourceType);
    os.writeInt32(5, this.iScreenType);
    os.writeInt64(6, this.lUid);
    os.writeInt32(7, this.iGameId);
    os.writeInt32(8, this.iRoomId);
};

HUYA.PresenterChannelInfo.prototype.readFrom = function (is)
{
    this.lYYId= is.readInt64(0, false, this.lYYId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.iSourceType= is.readInt32(4, false, this.iSourceType);
    this.iScreenType= is.readInt32(5, false, this.iScreenType);
    this.lUid= is.readInt64(6, false, this.lUid);
    this.iGameId= is.readInt32(7, false, this.iGameId);
    this.iRoomId= is.readInt32(8, false, this.iRoomId);
};

HUYA.FaithInfo = function()
{
    this.sFaithName = "";
    this.vPresenter = new Taf.Vector(new HUYA.FaithPresenter());
};
HUYA.FaithInfo.prototype._clone = function () { return new HUYA.FaithInfo(); }
HUYA.FaithInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FaithInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FaithInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sFaithName);
    os.writeVector(1, this.vPresenter);
};

HUYA.FaithInfo.prototype.readFrom = function (is)
{
    this.sFaithName= is.readString(0, false, this.sFaithName);
    this.vPresenter= is.readVector(1, false, this.vPresenter);
};

HUYA.GameLiveMisc = function()
{
    this.mMiscInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.sIP = "";
    this.sGuid = "";
    this.iPresentType = 0;
    this.sGPSInfo = "";
    this.lBonusValue = 0;
    this.sIPLocation = "";
    this.sHuYaUA = "";
    this.iScore = 0;
    this.lRealAttendeeCount = 0;
    this.lSubscribedCount = 0;
    this.mpAttribute = new Taf.Map(new Taf.STRING(), new HUYA.LiveAttributeInfo());
    this.sPassword = "";
};
HUYA.GameLiveMisc.prototype._clone = function () { return new HUYA.GameLiveMisc(); }
HUYA.GameLiveMisc.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveMisc.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveMisc.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mMiscInfo);
    os.writeString(1, this.sIP);
    os.writeString(2, this.sGuid);
    os.writeInt32(3, this.iPresentType);
    os.writeString(4, this.sGPSInfo);
    os.writeInt64(5, this.lBonusValue);
    os.writeString(6, this.sIPLocation);
    os.writeString(7, this.sHuYaUA);
    os.writeInt64(8, this.iScore);
    os.writeInt64(9, this.lRealAttendeeCount);
    os.writeInt64(10, this.lSubscribedCount);
    os.writeMap(11, this.mpAttribute);
    os.writeString(12, this.sPassword);
};

HUYA.GameLiveMisc.prototype.readFrom = function (is)
{
    this.mMiscInfo= is.readMap(0, false, this.mMiscInfo);
    this.sIP= is.readString(1, false, this.sIP);
    this.sGuid= is.readString(2, false, this.sGuid);
    this.iPresentType= is.readInt32(3, false, this.iPresentType);
    this.sGPSInfo= is.readString(4, false, this.sGPSInfo);
    this.lBonusValue= is.readInt64(5, false, this.lBonusValue);
    this.sIPLocation= is.readString(6, false, this.sIPLocation);
    this.sHuYaUA= is.readString(7, false, this.sHuYaUA);
    this.iScore= is.readInt64(8, false, this.iScore);
    this.lRealAttendeeCount= is.readInt64(9, false, this.lRealAttendeeCount);
    this.lSubscribedCount= is.readInt64(10, false, this.lSubscribedCount);
    this.mpAttribute= is.readMap(11, false, this.mpAttribute);
    this.sPassword= is.readString(12, false, this.sPassword);
};

HUYA.GameLiveInfo = function()
{
    this.lLiveId = 0;
    this.lUid = 0;
    this.lChannelId = 0;
    this.iShortChannel = 0;
    this.lSubchannel = 0;
    this.sSubchannelName = "";
    this.iGameId = 0;
    this.sGameName = "";
    this.iAttendeeCount = 0;
    this.eGender = HUYA.EGender.MALE;
    this.iAid = 0;
    this.sNick = "";
    this.sAvatarUrl = "";
    this.iStartTime = 0;
    this.iEndTime = 0;
    this.iSourceType = 0;
    this.bIsCameraOpen = false;
    this.bIsRoomSecret = false;
    this.sVideoCaptureUrl = "";
    this.iCdnAttendee = 0;
    this.lYYId = 0;
    this.bCertified = false;
    this.iRecType = 0;
    this.lSignChannel = 0;
    this.sLiveDesc = "";
    this.iLevel = 0;
    this.sGameShortName = "";
    this.iGameType = 0;
    this.sPrivateHost = "";
    this.iActivityCount = 0;
    this.iStreamType = 0;
    this.iBitRate = 0;
    this.iResolution = 0;
    this.iFrameRate = 0;
    this.iIsMultiStream = 0;
    this.iExeGameId = 0;
    this.lExp = 0;
    this.sReplayHls = "";
    this.lMultiStreamFlag = 0;
    this.iScreenType = 0;
    this.iChannelType = 0;
    this.sLocation = "";
    this.iCodecType = 0;
    this.vPresenterTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.vGameTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.lLiveCompatibleFlag = 0;
    this.sTraceId = "";
    this.iRoomId = 0;
};
HUYA.GameLiveInfo.prototype._clone = function () { return new HUYA.GameLiveInfo(); }
HUYA.GameLiveInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lLiveId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lChannelId);
    os.writeInt32(3, this.iShortChannel);
    os.writeInt64(4, this.lSubchannel);
    os.writeString(5, this.sSubchannelName);
    os.writeInt32(6, this.iGameId);
    os.writeString(7, this.sGameName);
    os.writeInt32(8, this.iAttendeeCount);
    os.writeInt32(9, this.eGender);
    os.writeInt32(10, this.iAid);
    os.writeString(11, this.sNick);
    os.writeString(12, this.sAvatarUrl);
    os.writeInt32(13, this.iStartTime);
    os.writeInt32(14, this.iEndTime);
    os.writeInt32(15, this.iSourceType);
    os.writeBoolean(16, this.bIsCameraOpen);
    os.writeBoolean(17, this.bIsRoomSecret);
    os.writeString(18, this.sVideoCaptureUrl);
    os.writeInt32(19, this.iCdnAttendee);
    os.writeInt64(20, this.lYYId);
    os.writeBoolean(21, this.bCertified);
    os.writeInt32(22, this.iRecType);
    os.writeInt64(23, this.lSignChannel);
    os.writeString(24, this.sLiveDesc);
    os.writeInt32(25, this.iLevel);
    os.writeString(26, this.sGameShortName);
    os.writeInt32(27, this.iGameType);
    os.writeString(28, this.sPrivateHost);
    os.writeInt32(29, this.iActivityCount);
    os.writeInt32(30, this.iStreamType);
    os.writeInt32(31, this.iBitRate);
    os.writeInt32(32, this.iResolution);
    os.writeInt32(33, this.iFrameRate);
    os.writeInt32(34, this.iIsMultiStream);
    os.writeInt32(35, this.iExeGameId);
    os.writeInt64(36, this.lExp);
    os.writeString(37, this.sReplayHls);
    os.writeInt64(38, this.lMultiStreamFlag);
    os.writeInt32(39, this.iScreenType);
    os.writeInt32(40, this.iChannelType);
    os.writeString(41, this.sLocation);
    os.writeInt32(42, this.iCodecType);
    os.writeVector(43, this.vPresenterTags);
    os.writeVector(44, this.vGameTags);
    os.writeInt64(45, this.lLiveCompatibleFlag);
    os.writeString(46, this.sTraceId);
    os.writeInt32(47, this.iRoomId);
};

HUYA.GameLiveInfo.prototype.readFrom = function (is)
{
    this.lLiveId= is.readInt64(0, false, this.lLiveId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lChannelId= is.readInt64(2, false, this.lChannelId);
    this.iShortChannel= is.readInt32(3, false, this.iShortChannel);
    this.lSubchannel= is.readInt64(4, false, this.lSubchannel);
    this.sSubchannelName= is.readString(5, false, this.sSubchannelName);
    this.iGameId= is.readInt32(6, false, this.iGameId);
    this.sGameName= is.readString(7, false, this.sGameName);
    this.iAttendeeCount= is.readInt32(8, false, this.iAttendeeCount);
    this.eGender= is.readInt32(9, false, this.eGender);
    this.iAid= is.readInt32(10, false, this.iAid);
    this.sNick= is.readString(11, false, this.sNick);
    this.sAvatarUrl= is.readString(12, false, this.sAvatarUrl);
    this.iStartTime= is.readInt32(13, false, this.iStartTime);
    this.iEndTime= is.readInt32(14, false, this.iEndTime);
    this.iSourceType= is.readInt32(15, false, this.iSourceType);
    this.bIsCameraOpen= is.readBoolean(16, false, this.bIsCameraOpen);
    this.bIsRoomSecret= is.readBoolean(17, false, this.bIsRoomSecret);
    this.sVideoCaptureUrl= is.readString(18, false, this.sVideoCaptureUrl);
    this.iCdnAttendee= is.readInt32(19, false, this.iCdnAttendee);
    this.lYYId= is.readInt64(20, false, this.lYYId);
    this.bCertified= is.readBoolean(21, false, this.bCertified);
    this.iRecType= is.readInt32(22, false, this.iRecType);
    this.lSignChannel= is.readInt64(23, false, this.lSignChannel);
    this.sLiveDesc= is.readString(24, false, this.sLiveDesc);
    this.iLevel= is.readInt32(25, false, this.iLevel);
    this.sGameShortName= is.readString(26, false, this.sGameShortName);
    this.iGameType= is.readInt32(27, false, this.iGameType);
    this.sPrivateHost= is.readString(28, false, this.sPrivateHost);
    this.iActivityCount= is.readInt32(29, false, this.iActivityCount);
    this.iStreamType= is.readInt32(30, false, this.iStreamType);
    this.iBitRate= is.readInt32(31, false, this.iBitRate);
    this.iResolution= is.readInt32(32, false, this.iResolution);
    this.iFrameRate= is.readInt32(33, false, this.iFrameRate);
    this.iIsMultiStream= is.readInt32(34, false, this.iIsMultiStream);
    this.iExeGameId= is.readInt32(35, false, this.iExeGameId);
    this.lExp= is.readInt64(36, false, this.lExp);
    this.sReplayHls= is.readString(37, false, this.sReplayHls);
    this.lMultiStreamFlag= is.readInt64(38, false, this.lMultiStreamFlag);
    this.iScreenType= is.readInt32(39, false, this.iScreenType);
    this.iChannelType= is.readInt32(40, false, this.iChannelType);
    this.sLocation= is.readString(41, false, this.sLocation);
    this.iCodecType= is.readInt32(42, false, this.iCodecType);
    this.vPresenterTags= is.readVector(43, false, this.vPresenterTags);
    this.vGameTags= is.readVector(44, false, this.vGameTags);
    this.lLiveCompatibleFlag= is.readInt64(45, false, this.lLiveCompatibleFlag);
    this.sTraceId= is.readString(46, false, this.sTraceId);
    this.iRoomId= is.readInt32(47, false, this.iRoomId);
};

HUYA.NobleInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.lValidDate = 0;
    this.sNobleName = "";
    this.iNobleLevel = 0;
    this.iNoblePet = 0;
    this.iNobleStatus = 0;
    this.iNobleType = 0;
    this.iRemainDays = 0;
    this.tLevelAttr = new HUYA.NobleLevelAttr();
    this.tPetAttr = new HUYA.NoblePetAttr();
    this.lOpenTime = 0;
};
HUYA.NobleInfo.prototype._clone = function () { return new HUYA.NobleInfo(); }
HUYA.NobleInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt64(2, this.lValidDate);
    os.writeString(3, this.sNobleName);
    os.writeInt32(4, this.iNobleLevel);
    os.writeInt32(5, this.iNoblePet);
    os.writeInt32(6, this.iNobleStatus);
    os.writeInt32(7, this.iNobleType);
    os.writeInt32(8, this.iRemainDays);
    os.writeStruct(9, this.tLevelAttr);
    os.writeStruct(10, this.tPetAttr);
    os.writeInt64(11, this.lOpenTime);
};

HUYA.NobleInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.lValidDate= is.readInt64(2, false, this.lValidDate);
    this.sNobleName= is.readString(3, false, this.sNobleName);
    this.iNobleLevel= is.readInt32(4, false, this.iNobleLevel);
    this.iNoblePet= is.readInt32(5, false, this.iNoblePet);
    this.iNobleStatus= is.readInt32(6, false, this.iNobleStatus);
    this.iNobleType= is.readInt32(7, false, this.iNobleType);
    this.iRemainDays= is.readInt32(8, false, this.iRemainDays);
    this.tLevelAttr= is.readStruct(9, false, this.tLevelAttr);
    this.tPetAttr= is.readStruct(10, false, this.tPetAttr);
    this.lOpenTime= is.readInt64(11, false, this.lOpenTime);
};

HUYA.FansAwardInfo = function()
{
    this.iAwardType = 0;
    this.vAwardPid = new Taf.Vector(new Taf.INT64());
    this.mpAwardExt = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.FansAwardInfo.prototype._clone = function () { return new HUYA.FansAwardInfo(); }
HUYA.FansAwardInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FansAwardInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FansAwardInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAwardType);
    os.writeVector(1, this.vAwardPid);
    os.writeMap(2, this.mpAwardExt);
};

HUYA.FansAwardInfo.prototype.readFrom = function (is)
{
    this.iAwardType= is.readInt32(0, false, this.iAwardType);
    this.vAwardPid= is.readVector(1, false, this.vAwardPid);
    this.mpAwardExt= is.readMap(2, false, this.mpAwardExt);
};

HUYA.SenderInfo = function()
{
    this.lUid = 0;
    this.lImid = 0;
    this.sNickName = "";
    this.iGender = 0;
    this.sAvatarUrl = "";
    this.iNobleLevel = 0;
    this.tNobleLevelInfo = new HUYA.NobleLevelInfo();
    this.sGuid = "";
    this.sHuYaUA = "";
};
HUYA.SenderInfo.prototype._clone = function () { return new HUYA.SenderInfo(); }
HUYA.SenderInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SenderInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SenderInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lImid);
    os.writeString(2, this.sNickName);
    os.writeInt32(3, this.iGender);
    os.writeString(4, this.sAvatarUrl);
    os.writeInt32(5, this.iNobleLevel);
    os.writeStruct(6, this.tNobleLevelInfo);
    os.writeString(7, this.sGuid);
    os.writeString(8, this.sHuYaUA);
};

HUYA.SenderInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lImid= is.readInt64(1, false, this.lImid);
    this.sNickName= is.readString(2, false, this.sNickName);
    this.iGender= is.readInt32(3, false, this.iGender);
    this.sAvatarUrl= is.readString(4, false, this.sAvatarUrl);
    this.iNobleLevel= is.readInt32(5, false, this.iNobleLevel);
    this.tNobleLevelInfo= is.readStruct(6, false, this.tNobleLevelInfo);
    this.sGuid= is.readString(7, false, this.sGuid);
    this.sHuYaUA= is.readString(8, false, this.sHuYaUA);
};

HUYA.DecorationInfo = function()
{
    this.iAppId = 0;
    this.iViewType = 0;
    this.vData = new Taf.BinBuffer();
};
HUYA.DecorationInfo.prototype._clone = function () { return new HUYA.DecorationInfo(); }
HUYA.DecorationInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAppId);
    os.writeInt32(1, this.iViewType);
    os.writeBytes(2, this.vData);
};

HUYA.DecorationInfo.prototype.readFrom = function (is)
{
    this.iAppId= is.readInt32(0, false, this.iAppId);
    this.iViewType= is.readInt32(1, false, this.iViewType);
    this.vData= is.readBytes(2, false, this.vData);
};

HUYA.ChannelPair = function()
{
    this.lTid = 0;
    this.lSid = 0;
    this.lPid = 0;
};
HUYA.ChannelPair.prototype._clone = function () { return new HUYA.ChannelPair(); }
HUYA.ChannelPair.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ChannelPair.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ChannelPair.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTid);
    os.writeInt64(1, this.lSid);
    os.writeInt64(2, this.lPid);
};

HUYA.ChannelPair.prototype.readFrom = function (is)
{
    this.lTid= is.readInt64(0, false, this.lTid);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.lPid= is.readInt64(2, false, this.lPid);
};

HUYA.SendMessageReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lTid = 0;
    this.lSid = 0;
    this.sContent = "";
    this.iShowMode = 0;
    this.tFormat = new HUYA.ContentFormat();
    this.tBulletFormat = new HUYA.BulletFormat();
    this.vAtSomeone = new Taf.Vector(new HUYA.UidNickName());
    this.lPid = 0;
    this.vTagInfo = new Taf.Vector(new HUYA.MessageTagInfo());
};
HUYA.SendMessageReq.prototype._clone = function () { return new HUYA.SendMessageReq(); }
HUYA.SendMessageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendMessageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendMessageReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeString(3, this.sContent);
    os.writeInt32(4, this.iShowMode);
    os.writeStruct(5, this.tFormat);
    os.writeStruct(6, this.tBulletFormat);
    os.writeVector(7, this.vAtSomeone);
    os.writeInt64(8, this.lPid);
    os.writeVector(9, this.vTagInfo);
};

HUYA.SendMessageReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.sContent= is.readString(3, false, this.sContent);
    this.iShowMode= is.readInt32(4, false, this.iShowMode);
    this.tFormat= is.readStruct(5, false, this.tFormat);
    this.tBulletFormat= is.readStruct(6, false, this.tBulletFormat);
    this.vAtSomeone= is.readVector(7, false, this.vAtSomeone);
    this.lPid= is.readInt64(8, false, this.lPid);
    this.vTagInfo= is.readVector(9, false, this.vTagInfo);
};

HUYA.BadgeInfo = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.sPresenterNickName = "";
    this.sBadgeName = "";
    this.iBadgeLevel = 0;
    this.iRank = 0;
    this.iScore = 0;
    this.iNextScore = 0;
    this.iQuotaUsed = 0;
    this.iQuota = 0;
    this.lQuotaTS = 0;
    this.lOpenTS = 0;
    this.iVFlag = 0;
    this.sVLogo = "";
    this.tChannelInfo = new HUYA.PresenterChannelInfo();
    this.sPresenterLogo = "";
    this.lVExpiredTS = 0;
    this.iBadgeType = 0;
    this.tFaithInfo = new HUYA.FaithInfo();
    this.tSuperFansInfo = new HUYA.SuperFansInfo();
    this.iBaseQuota = 0;
    this.lVConsumRank = 0;
};
HUYA.BadgeInfo.prototype._clone = function () { return new HUYA.BadgeInfo(); }
HUYA.BadgeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeString(2, this.sPresenterNickName);
    os.writeString(3, this.sBadgeName);
    os.writeInt32(4, this.iBadgeLevel);
    os.writeInt32(5, this.iRank);
    os.writeInt32(6, this.iScore);
    os.writeInt32(7, this.iNextScore);
    os.writeInt32(8, this.iQuotaUsed);
    os.writeInt32(9, this.iQuota);
    os.writeInt64(10, this.lQuotaTS);
    os.writeInt64(11, this.lOpenTS);
    os.writeInt32(12, this.iVFlag);
    os.writeString(13, this.sVLogo);
    os.writeStruct(14, this.tChannelInfo);
    os.writeString(15, this.sPresenterLogo);
    os.writeInt64(16, this.lVExpiredTS);
    os.writeInt32(17, this.iBadgeType);
    os.writeStruct(18, this.tFaithInfo);
    os.writeStruct(19, this.tSuperFansInfo);
    os.writeInt32(20, this.iBaseQuota);
    os.writeInt64(21, this.lVConsumRank);
};

HUYA.BadgeInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.sPresenterNickName= is.readString(2, false, this.sPresenterNickName);
    this.sBadgeName= is.readString(3, false, this.sBadgeName);
    this.iBadgeLevel= is.readInt32(4, false, this.iBadgeLevel);
    this.iRank= is.readInt32(5, false, this.iRank);
    this.iScore= is.readInt32(6, false, this.iScore);
    this.iNextScore= is.readInt32(7, false, this.iNextScore);
    this.iQuotaUsed= is.readInt32(8, false, this.iQuotaUsed);
    this.iQuota= is.readInt32(9, false, this.iQuota);
    this.lQuotaTS= is.readInt64(10, false, this.lQuotaTS);
    this.lOpenTS= is.readInt64(11, false, this.lOpenTS);
    this.iVFlag= is.readInt32(12, false, this.iVFlag);
    this.sVLogo= is.readString(13, false, this.sVLogo);
    this.tChannelInfo= is.readStruct(14, false, this.tChannelInfo);
    this.sPresenterLogo= is.readString(15, false, this.sPresenterLogo);
    this.lVExpiredTS= is.readInt64(16, false, this.lVExpiredTS);
    this.iBadgeType= is.readInt32(17, false, this.iBadgeType);
    this.tFaithInfo= is.readStruct(18, false, this.tFaithInfo);
    this.tSuperFansInfo= is.readStruct(19, false, this.tSuperFansInfo);
    this.iBaseQuota= is.readInt32(20, false, this.iBaseQuota);
    this.lVConsumRank= is.readInt64(21, false, this.lVConsumRank);
};

HUYA.ActivityTimeEventType = function()
{
    this.iIgnoreIfExists = 0;
    this.iBroadcastTrigger = 0;
    this.iPeriod = 0;
};
HUYA.ActivityTimeEventType.prototype._clone = function () { return new HUYA.ActivityTimeEventType(); }
HUYA.ActivityTimeEventType.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEventType.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEventType.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iIgnoreIfExists);
    os.writeInt32(1, this.iBroadcastTrigger);
    os.writeInt32(2, this.iPeriod);
};

HUYA.ActivityTimeEventType.prototype.readFrom = function (is)
{
    this.iIgnoreIfExists= is.readInt32(0, false, this.iIgnoreIfExists);
    this.iBroadcastTrigger= is.readInt32(1, false, this.iBroadcastTrigger);
    this.iPeriod= is.readInt32(2, false, this.iPeriod);
};

HUYA.ActivityTimeEventCBData = function()
{
    this.lTid = 0;
    this.lSid = 0;
    this.sReserved = "";
    this.lHashCode = -1;
};
HUYA.ActivityTimeEventCBData.prototype._clone = function () { return new HUYA.ActivityTimeEventCBData(); }
HUYA.ActivityTimeEventCBData.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEventCBData.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEventCBData.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTid);
    os.writeInt64(1, this.lSid);
    os.writeString(2, this.sReserved);
    os.writeInt64(3, this.lHashCode);
};

HUYA.ActivityTimeEventCBData.prototype.readFrom = function (is)
{
    this.lTid= is.readInt64(0, false, this.lTid);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.sReserved= is.readString(2, false, this.sReserved);
    this.lHashCode= is.readInt64(3, false, this.lHashCode);
};

HUYA.ActivitySerializedMsg = function()
{
    this.iSubUri = 0;
    this.vContent = new Taf.BinBuffer();
};
HUYA.ActivitySerializedMsg.prototype._clone = function () { return new HUYA.ActivitySerializedMsg(); }
HUYA.ActivitySerializedMsg.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivitySerializedMsg.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivitySerializedMsg.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iSubUri);
    os.writeBytes(1, this.vContent);
};

HUYA.ActivitySerializedMsg.prototype.readFrom = function (is)
{
    this.iSubUri= is.readInt32(0, false, this.iSubUri);
    this.vContent= is.readBytes(1, false, this.vContent);
};

var ActSchedule = ActSchedule || {};


ActSchedule.MatchResultGroup = function()
{
    this.iGroup = 0;
    this.vWinner = new Taf.Vector(new Taf.INT64());
    this.vLosers = new Taf.Vector(new Taf.INT64());
};
ActSchedule.MatchResultGroup.prototype._clone = function () { return new ActSchedule.MatchResultGroup(); }
ActSchedule.MatchResultGroup.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActSchedule.MatchResultGroup.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActSchedule.MatchResultGroup.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iGroup);
    os.writeVector(1, this.vWinner);
    os.writeVector(2, this.vLosers);
};

ActSchedule.MatchResultGroup.prototype.readFrom = function (is)
{
    this.iGroup= is.readInt32(0, false, this.iGroup);
    this.vWinner= is.readVector(1, false, this.vWinner);
    this.vLosers= is.readVector(2, false, this.vLosers);
};


ActSchedule.MatchGroup = function()
{
    this.iGroup = 0;
    this.vPlayers = new Taf.Vector(new Taf.INT64());
};
ActSchedule.MatchGroup.prototype._clone = function () { return new ActSchedule.MatchGroup(); }
ActSchedule.MatchGroup.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActSchedule.MatchGroup.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActSchedule.MatchGroup.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iGroup);
    os.writeVector(1, this.vPlayers);
};

ActSchedule.MatchGroup.prototype.readFrom = function (is)
{
    this.iGroup= is.readInt32(0, false, this.iGroup);
    this.vPlayers= is.readVector(1, false, this.vPlayers);
};

var ActPK = ActPK || {};


ActPK.ActPKMember = function()
{
    this.lPid = 0;
    this.iSide = 0;
    this.iPos = 0;
    this.lScore = 0;
    this.lData = 0;
};
ActPK.ActPKMember.prototype._clone = function () { return new ActPK.ActPKMember(); }
ActPK.ActPKMember.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKMember.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKMember.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iSide);
    os.writeInt32(2, this.iPos);
    os.writeInt64(3, this.lScore);
    os.writeInt64(4, this.lData);
};

ActPK.ActPKMember.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iSide= is.readInt32(1, false, this.iSide);
    this.iPos= is.readInt32(2, false, this.iPos);
    this.lScore= is.readInt64(3, false, this.lScore);
    this.lData= is.readInt64(4, false, this.lData);
};


HUYA.VipInfoChangedReq = function()
{
    this.iVipType = 0;
    this.lUid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.lPid = 0;
    this.lLevel = 0;
    this.sSerializeData = "";
};
HUYA.VipInfoChangedReq.prototype._clone = function () { return new HUYA.VipInfoChangedReq(); }
HUYA.VipInfoChangedReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VipInfoChangedReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VipInfoChangedReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iVipType);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt64(4, this.lPid);
    os.writeInt64(5, this.lLevel);
    os.writeString(6, this.sSerializeData);
};

HUYA.VipInfoChangedReq.prototype.readFrom = function (is)
{
    this.iVipType= is.readInt32(0, false, this.iVipType);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lTid= is.readInt64(2, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.lPid= is.readInt64(4, false, this.lPid);
    this.lLevel= is.readInt64(5, false, this.lLevel);
    this.sSerializeData= is.readString(6, false, this.sSerializeData);
};

HUYA.UsingBadgeUpdated = function()
{
    this.lUid = 0;
    this.iOriginalBadgeId = 0;
    this.iBadgeId = 0;
};
HUYA.UsingBadgeUpdated.prototype._clone = function () { return new HUYA.UsingBadgeUpdated(); }
HUYA.UsingBadgeUpdated.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UsingBadgeUpdated.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UsingBadgeUpdated.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.iOriginalBadgeId);
    os.writeInt64(2, this.iBadgeId);
};

HUYA.UsingBadgeUpdated.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.iOriginalBadgeId= is.readInt64(1, false, this.iOriginalBadgeId);
    this.iBadgeId= is.readInt64(2, false, this.iBadgeId);
};

HUYA.UserSessionBeginEvent = function()
{
    this.sSessionId = "";
    this.tId = new HUYA.UserId();
    this.lTopCid = 0;
    this.lSubCid = 0;
    this.lBegintime = 0;
    this.sTraceSource = "";
    this.sClientIp = "";
    this.bAnonymous = true;
    this.lPid = 0;
};
HUYA.UserSessionBeginEvent.prototype._clone = function () { return new HUYA.UserSessionBeginEvent(); }
HUYA.UserSessionBeginEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserSessionBeginEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserSessionBeginEvent.prototype.writeTo = function (os)
{
    os.writeString(0, this.sSessionId);
    os.writeStruct(1, this.tId);
    os.writeInt64(2, this.lTopCid);
    os.writeInt64(3, this.lSubCid);
    os.writeInt64(4, this.lBegintime);
    os.writeString(5, this.sTraceSource);
    os.writeString(6, this.sClientIp);
    os.writeBoolean(7, this.bAnonymous);
    os.writeInt64(8, this.lPid);
};

HUYA.UserSessionBeginEvent.prototype.readFrom = function (is)
{
    this.sSessionId= is.readString(0, false, this.sSessionId);
    this.tId= is.readStruct(1, false, this.tId);
    this.lTopCid= is.readInt64(2, false, this.lTopCid);
    this.lSubCid= is.readInt64(3, false, this.lSubCid);
    this.lBegintime= is.readInt64(4, false, this.lBegintime);
    this.sTraceSource= is.readString(5, false, this.sTraceSource);
    this.sClientIp= is.readString(6, false, this.sClientIp);
    this.bAnonymous= is.readBoolean(7, false, this.bAnonymous);
    this.lPid= is.readInt64(8, false, this.lPid);
};

HUYA.SendItemEdgeEventReq = function()
{
    this.tId = new HUYA.UserId();
    this.lSid = 0;
    this.lSubSid = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lPresenterUid = 0;
    this.sPayId = "";
    this.sSenderNick = "";
    this.sPresenterNick = "";
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.iSuperPupleLevel = 0;
    this.iFromType = 0;
    this.iPayType = 0;
    this.iTemplateType = 0;
    this.iTotalPay = 0;
    this.sExpand = "";
    this.iIsGroup = 0;
    this.bWorldBanner = true;
    this.iEffectType = 0;
    this.iColorEffectType = 0;
    this.iWeekStart = 0;
    this.lPayTime = 0;
    this.lGameId = 0;
    this.iItemEventType = 0;
    this.sItemEventContent = "";
    this.sSenderIcon = "";
    this.sPresenterIcon = "";
    this.lRoomId = 0;
    this.lHomeOwnerUid = 0;
    this.lLiveId = 0;
    this.lMicUid = 0;
};
HUYA.SendItemEdgeEventReq.prototype._clone = function () { return new HUYA.SendItemEdgeEventReq(); }
HUYA.SendItemEdgeEventReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendItemEdgeEventReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendItemEdgeEventReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lSid);
    os.writeInt64(2, this.lSubSid);
    os.writeInt32(3, this.iItemType);
    os.writeInt32(4, this.iItemCount);
    os.writeInt64(5, this.lPresenterUid);
    os.writeString(6, this.sPayId);
    os.writeString(7, this.sSenderNick);
    os.writeString(8, this.sPresenterNick);
    os.writeInt32(9, this.iItemCountByGroup);
    os.writeInt32(10, this.iItemGroup);
    os.writeInt32(11, this.iSuperPupleLevel);
    os.writeInt32(12, this.iFromType);
    os.writeInt32(13, this.iPayType);
    os.writeInt32(14, this.iTemplateType);
    os.writeInt32(15, this.iTotalPay);
    os.writeString(16, this.sExpand);
    os.writeInt16(17, this.iIsGroup);
    os.writeBoolean(18, this.bWorldBanner);
    os.writeInt32(19, this.iEffectType);
    os.writeInt32(20, this.iColorEffectType);
    os.writeInt16(21, this.iWeekStart);
    os.writeInt64(22, this.lPayTime);
    os.writeInt64(23, this.lGameId);
    os.writeInt16(24, this.iItemEventType);
    os.writeString(25, this.sItemEventContent);
    os.writeString(26, this.sSenderIcon);
    os.writeString(27, this.sPresenterIcon);
    os.writeInt64(28, this.lRoomId);
    os.writeInt64(29, this.lHomeOwnerUid);
    os.writeInt64(30, this.lLiveId);
    os.writeInt64(31, this.lMicUid);
};

HUYA.SendItemEdgeEventReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.lSubSid= is.readInt64(2, false, this.lSubSid);
    this.iItemType= is.readInt32(3, false, this.iItemType);
    this.iItemCount= is.readInt32(4, false, this.iItemCount);
    this.lPresenterUid= is.readInt64(5, false, this.lPresenterUid);
    this.sPayId= is.readString(6, false, this.sPayId);
    this.sSenderNick= is.readString(7, false, this.sSenderNick);
    this.sPresenterNick= is.readString(8, false, this.sPresenterNick);
    this.iItemCountByGroup= is.readInt32(9, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(10, false, this.iItemGroup);
    this.iSuperPupleLevel= is.readInt32(11, false, this.iSuperPupleLevel);
    this.iFromType= is.readInt32(12, false, this.iFromType);
    this.iPayType= is.readInt32(13, false, this.iPayType);
    this.iTemplateType= is.readInt32(14, false, this.iTemplateType);
    this.iTotalPay= is.readInt32(15, false, this.iTotalPay);
    this.sExpand= is.readString(16, false, this.sExpand);
    this.iIsGroup= is.readInt16(17, false, this.iIsGroup);
    this.bWorldBanner= is.readBoolean(18, false, this.bWorldBanner);
    this.iEffectType= is.readInt32(19, false, this.iEffectType);
    this.iColorEffectType= is.readInt32(20, false, this.iColorEffectType);
    this.iWeekStart= is.readInt16(21, false, this.iWeekStart);
    this.lPayTime= is.readInt64(22, false, this.lPayTime);
    this.lGameId= is.readInt64(23, false, this.lGameId);
    this.iItemEventType= is.readInt16(24, false, this.iItemEventType);
    this.sItemEventContent= is.readString(25, false, this.sItemEventContent);
    this.sSenderIcon= is.readString(26, false, this.sSenderIcon);
    this.sPresenterIcon= is.readString(27, false, this.sPresenterIcon);
    this.lRoomId= is.readInt64(28, false, this.lRoomId);
    this.lHomeOwnerUid= is.readInt64(29, false, this.lHomeOwnerUid);
    this.lLiveId= is.readInt64(30, false, this.lLiveId);
    this.lMicUid= is.readInt64(31, false, this.lMicUid);
};

HUYA.PresenterHeartbeatEvent = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
    this.mReportMessage = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.PresenterHeartbeatEvent.prototype._clone = function () { return new HUYA.PresenterHeartbeatEvent(); }
HUYA.PresenterHeartbeatEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterHeartbeatEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterHeartbeatEvent.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeStruct(1, this.tGameLiveMisc);
    os.writeMap(2, this.mReportMessage);
};

HUYA.PresenterHeartbeatEvent.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.tGameLiveMisc= is.readStruct(1, false, this.tGameLiveMisc);
    this.mReportMessage= is.readMap(2, false, this.mReportMessage);
};

HUYA.NobleLevelChangedReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.tNoble = new HUYA.NobleInfo();
    this.iOpType = 0;
    this.iType = 0;
    this.lOldValidDate = 0;
    this.tOldLevel = new HUYA.NobleLevelInfo();
};
HUYA.NobleLevelChangedReq.prototype._clone = function () { return new HUYA.NobleLevelChangedReq(); }
HUYA.NobleLevelChangedReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleLevelChangedReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleLevelChangedReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeStruct(1, this.tNoble);
    os.writeInt32(2, this.iOpType);
    os.writeInt32(3, this.iType);
    os.writeInt64(4, this.lOldValidDate);
    os.writeStruct(5, this.tOldLevel);
};

HUYA.NobleLevelChangedReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.tNoble= is.readStruct(1, false, this.tNoble);
    this.iOpType= is.readInt32(2, false, this.iOpType);
    this.iType= is.readInt32(3, false, this.iType);
    this.lOldValidDate= is.readInt64(4, false, this.lOldValidDate);
    this.tOldLevel= is.readStruct(5, false, this.tOldLevel);
};

HUYA.LiveShareEventReq = function()
{
    this.tId = new HUYA.UserId();
    this.sTitle = "";
    this.sSubTitle = "";
    this.sContent = "";
    this.sAction = "";
    this.lPresenterUid = 0;
    this.iPlatform = 0;
    this.sImageUrl = "";
    this.lYYId = 0;
    this.lLiveId = 0;
    this.iShareType = 0;
};
HUYA.LiveShareEventReq.prototype._clone = function () { return new HUYA.LiveShareEventReq(); }
HUYA.LiveShareEventReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveShareEventReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveShareEventReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeString(1, this.sTitle);
    os.writeString(2, this.sSubTitle);
    os.writeString(3, this.sContent);
    os.writeString(4, this.sAction);
    os.writeInt64(5, this.lPresenterUid);
    os.writeInt32(6, this.iPlatform);
    os.writeString(7, this.sImageUrl);
    os.writeInt64(8, this.lYYId);
    os.writeInt64(9, this.lLiveId);
    os.writeInt32(10, this.iShareType);
};

HUYA.LiveShareEventReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.sTitle= is.readString(1, false, this.sTitle);
    this.sSubTitle= is.readString(2, false, this.sSubTitle);
    this.sContent= is.readString(3, false, this.sContent);
    this.sAction= is.readString(4, false, this.sAction);
    this.lPresenterUid= is.readInt64(5, false, this.lPresenterUid);
    this.iPlatform= is.readInt32(6, false, this.iPlatform);
    this.sImageUrl= is.readString(7, false, this.sImageUrl);
    this.lYYId= is.readInt64(8, false, this.lYYId);
    this.lLiveId= is.readInt64(9, false, this.lLiveId);
    this.iShareType= is.readInt32(10, false, this.iShareType);
};

HUYA.GetActFansAwardInfoRsp = function()
{
    this.vInfo = new Taf.Vector(new HUYA.FansAwardInfo());
};
HUYA.GetActFansAwardInfoRsp.prototype._clone = function () { return new HUYA.GetActFansAwardInfoRsp(); }
HUYA.GetActFansAwardInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetActFansAwardInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetActFansAwardInfoRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vInfo);
};

HUYA.GetActFansAwardInfoRsp.prototype.readFrom = function (is)
{
    this.vInfo= is.readVector(0, false, this.vInfo);
};

HUYA.GetActFansAwardInfoReq = function()
{
    this.lUid = 0;
};
HUYA.GetActFansAwardInfoReq.prototype._clone = function () { return new HUYA.GetActFansAwardInfoReq(); }
HUYA.GetActFansAwardInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetActFansAwardInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetActFansAwardInfoReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
};

HUYA.GetActFansAwardInfoReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
};

HUYA.EndLiveEventNotifyReq = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.iReason = 0;
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
};
HUYA.EndLiveEventNotifyReq.prototype._clone = function () { return new HUYA.EndLiveEventNotifyReq(); }
HUYA.EndLiveEventNotifyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.EndLiveEventNotifyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.EndLiveEventNotifyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeInt32(1, this.iReason);
    os.writeStruct(2, this.tGameLiveMisc);
};

HUYA.EndLiveEventNotifyReq.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.iReason= is.readInt32(1, false, this.iReason);
    this.tGameLiveMisc= is.readStruct(2, false, this.tGameLiveMisc);
};

HUYA.DecorationInfoRsp = function()
{
    this.vDecorationPrefix = new Taf.Vector(new HUYA.DecorationInfo());
    this.vDecorationSuffix = new Taf.Vector(new HUYA.DecorationInfo());
    this.tFormat = new HUYA.ContentFormat();
    this.tBulletFormat = new HUYA.BulletFormat();
    this.vForwardChannels = new Taf.Vector(new HUYA.ChannelPair());
    this.iModifyMask = 0;
    this.vBulletPrefix = new Taf.Vector(new HUYA.DecorationInfo());
    this.tUserInfo = new HUYA.SenderInfo();
    this.vBulletSuffix = new Taf.Vector(new HUYA.DecorationInfo());
};
HUYA.DecorationInfoRsp.prototype._clone = function () { return new HUYA.DecorationInfoRsp(); }
HUYA.DecorationInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfoRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vDecorationPrefix);
    os.writeVector(1, this.vDecorationSuffix);
    os.writeStruct(2, this.tFormat);
    os.writeStruct(3, this.tBulletFormat);
    os.writeVector(4, this.vForwardChannels);
    os.writeInt32(5, this.iModifyMask);
    os.writeVector(6, this.vBulletPrefix);
    os.writeStruct(7, this.tUserInfo);
    os.writeVector(8, this.vBulletSuffix);
};

HUYA.DecorationInfoRsp.prototype.readFrom = function (is)
{
    this.vDecorationPrefix= is.readVector(0, false, this.vDecorationPrefix);
    this.vDecorationSuffix= is.readVector(1, false, this.vDecorationSuffix);
    this.tFormat= is.readStruct(2, false, this.tFormat);
    this.tBulletFormat= is.readStruct(3, false, this.tBulletFormat);
    this.vForwardChannels= is.readVector(4, false, this.vForwardChannels);
    this.iModifyMask= is.readInt32(5, false, this.iModifyMask);
    this.vBulletPrefix= is.readVector(6, false, this.vBulletPrefix);
    this.tUserInfo= is.readStruct(7, false, this.tUserInfo);
    this.vBulletSuffix= is.readVector(8, false, this.vBulletSuffix);
};

HUYA.DecorationInfoReq = function()
{
    this.tSendMsgReq = new HUYA.SendMessageReq();
};
HUYA.DecorationInfoReq.prototype._clone = function () { return new HUYA.DecorationInfoReq(); }
HUYA.DecorationInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tSendMsgReq);
};

HUYA.DecorationInfoReq.prototype.readFrom = function (is)
{
    this.tSendMsgReq= is.readStruct(0, false, this.tSendMsgReq);
};

HUYA.BeginLiveEventNotifyReq = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
};
HUYA.BeginLiveEventNotifyReq.prototype._clone = function () { return new HUYA.BeginLiveEventNotifyReq(); }
HUYA.BeginLiveEventNotifyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BeginLiveEventNotifyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BeginLiveEventNotifyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeStruct(1, this.tGameLiveMisc);
};

HUYA.BeginLiveEventNotifyReq.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.tGameLiveMisc= is.readStruct(1, false, this.tGameLiveMisc);
};

HUYA.BadgeUpdated = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.tOriginalInfo = new HUYA.BadgeInfo();
    this.tInfo = new HUYA.BadgeInfo();
    this.iItemType = 0;
};
HUYA.BadgeUpdated.prototype._clone = function () { return new HUYA.BadgeUpdated(); }
HUYA.BadgeUpdated.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeUpdated.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeUpdated.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeStruct(2, this.tOriginalInfo);
    os.writeStruct(3, this.tInfo);
    os.writeInt32(4, this.iItemType);
};

HUYA.BadgeUpdated.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.tOriginalInfo= is.readStruct(2, false, this.tOriginalInfo);
    this.tInfo= is.readStruct(3, false, this.tInfo);
    this.iItemType= is.readInt32(4, false, this.iItemType);
};

HUYA.ActivityTimeEvent = function()
{
    this.iActivityId = 0;
    this.lUid = 0;
    this.iEventId = 0;
    this.iTriggerDelay = 0;
    this.tType = new HUYA.ActivityTimeEventType();
    this.tCallBackData = new HUYA.ActivityTimeEventCBData();
};
HUYA.ActivityTimeEvent.prototype._clone = function () { return new HUYA.ActivityTimeEvent(); }
HUYA.ActivityTimeEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEvent.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iActivityId);
    os.writeInt64(1, this.lUid);
    os.writeInt32(2, this.iEventId);
    os.writeInt32(3, this.iTriggerDelay);
    os.writeStruct(4, this.tType);
    os.writeStruct(5, this.tCallBackData);
};

HUYA.ActivityTimeEvent.prototype.readFrom = function (is)
{
    this.iActivityId= is.readInt32(0, false, this.iActivityId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.iEventId= is.readInt32(2, false, this.iEventId);
    this.iTriggerDelay= is.readInt32(3, false, this.iTriggerDelay);
    this.tType= is.readStruct(4, false, this.tType);
    this.tCallBackData= is.readStruct(5, false, this.tCallBackData);
};

HUYA.ActivityTestRsp = function()
{
    this.sRet = "";
};
HUYA.ActivityTestRsp.prototype._clone = function () { return new HUYA.ActivityTestRsp(); }
HUYA.ActivityTestRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTestRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTestRsp.prototype.writeTo = function (os)
{
    os.writeString(0, this.sRet);
};

HUYA.ActivityTestRsp.prototype.readFrom = function (is)
{
    this.sRet= is.readString(0, false, this.sRet);
};

HUYA.ActivityTestReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.iActivityId = 0;
    this.lPid = 0;
    this.sContext = "";
};
HUYA.ActivityTestReq.prototype._clone = function () { return new HUYA.ActivityTestReq(); }
HUYA.ActivityTestReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTestReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTestReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt32(1, this.iActivityId);
    os.writeInt64(2, this.lPid);
    os.writeString(3, this.sContext);
};

HUYA.ActivityTestReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.sContext= is.readString(3, false, this.sContext);
};

HUYA.ActivityMsgRsp = function()
{
    this.iEnable = 0;
    this.vSerializedMsg = new Taf.Vector(new HUYA.ActivitySerializedMsg());
    this.iTimeStamp = 0;
};
HUYA.ActivityMsgRsp.prototype._clone = function () { return new HUYA.ActivityMsgRsp(); }
HUYA.ActivityMsgRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityMsgRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityMsgRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iEnable);
    os.writeVector(1, this.vSerializedMsg);
    os.writeInt32(2, this.iTimeStamp);
};

HUYA.ActivityMsgRsp.prototype.readFrom = function (is)
{
    this.iEnable= is.readInt32(0, false, this.iEnable);
    this.vSerializedMsg= is.readVector(1, false, this.vSerializedMsg);
    this.iTimeStamp= is.readInt32(2, false, this.iTimeStamp);
};

HUYA.ActivityMsgReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.iActivityId = 0;
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iChannelType = 0;
    this.iSubUri = 0;
};
HUYA.ActivityMsgReq.prototype._clone = function () { return new HUYA.ActivityMsgReq(); }
HUYA.ActivityMsgReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityMsgReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityMsgReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt32(1, this.iActivityId);
    os.writeInt64(2, this.lPid);
    os.writeInt64(3, this.lTid);
    os.writeInt64(4, this.lSid);
    os.writeInt32(5, this.iChannelType);
    os.writeInt32(6, this.iSubUri);
};

HUYA.ActivityMsgReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.lTid= is.readInt64(3, false, this.lTid);
    this.lSid= is.readInt64(4, false, this.lSid);
    this.iChannelType= is.readInt32(5, false, this.iChannelType);
    this.iSubUri= is.readInt32(6, false, this.iSubUri);
};


ActSchedule.ActStageInfo = function()
{
    this.lActId = 0;
    this.iStage = 0;
    this.lStageStart = 0;
    this.iDay = 0;
    this.iTotalDay = 0;
    this.iHour = 0;
    this.iMinute = 0;
    this.iSecondsPerDay = 0;
};
ActSchedule.ActStageInfo.prototype._clone = function () { return new ActSchedule.ActStageInfo(); }
ActSchedule.ActStageInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActSchedule.ActStageInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActSchedule.ActStageInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lActId);
    os.writeInt32(1, this.iStage);
    os.writeInt64(2, this.lStageStart);
    os.writeInt32(3, this.iDay);
    os.writeInt32(4, this.iTotalDay);
    os.writeInt32(5, this.iHour);
    os.writeInt32(6, this.iMinute);
    os.writeInt32(7, this.iSecondsPerDay);
};

ActSchedule.ActStageInfo.prototype.readFrom = function (is)
{
    this.lActId= is.readInt64(0, false, this.lActId);
    this.iStage= is.readInt32(1, false, this.iStage);
    this.lStageStart= is.readInt64(2, false, this.lStageStart);
    this.iDay= is.readInt32(3, false, this.iDay);
    this.iTotalDay= is.readInt32(4, false, this.iTotalDay);
    this.iHour= is.readInt32(5, false, this.iHour);
    this.iMinute= is.readInt32(6, false, this.iMinute);
    this.iSecondsPerDay= is.readInt32(7, false, this.iSecondsPerDay);
};


ActSchedule.ActStageChangedInfo = function()
{
    this.lActId = 0;
    this.iArea = 0;
    this.iStage = 0;
    this.tLastResults = new Taf.Vector(new ActSchedule.MatchResultGroup());
    this.tCurrentGroups = new Taf.Vector(new ActSchedule.MatchGroup());
};
ActSchedule.ActStageChangedInfo.prototype._clone = function () { return new ActSchedule.ActStageChangedInfo(); }
ActSchedule.ActStageChangedInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActSchedule.ActStageChangedInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActSchedule.ActStageChangedInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lActId);
    os.writeInt32(1, this.iArea);
    os.writeInt32(2, this.iStage);
    os.writeVector(3, this.tLastResults);
    os.writeVector(4, this.tCurrentGroups);
};

ActSchedule.ActStageChangedInfo.prototype.readFrom = function (is)
{
    this.lActId= is.readInt64(0, false, this.lActId);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.iStage= is.readInt32(2, false, this.iStage);
    this.tLastResults= is.readVector(3, false, this.tLastResults);
    this.tCurrentGroups= is.readVector(4, false, this.tCurrentGroups);
};


ActPK.ActPKUpdateInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lScore = 0;
    this.bIsOrder = false;
    this.iBroadcast = 0;
    this.lMicUid = 0;
};
ActPK.ActPKUpdateInfo.prototype._clone = function () { return new ActPK.ActPKUpdateInfo(); }
ActPK.ActPKUpdateInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKUpdateInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKUpdateInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iItemType);
    os.writeInt32(3, this.iItemCount);
    os.writeInt64(4, this.lScore);
    os.writeBoolean(5, this.bIsOrder);
    os.writeInt32(6, this.iBroadcast);
    os.writeInt64(7, this.lMicUid);
};

ActPK.ActPKUpdateInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iItemType= is.readInt32(2, false, this.iItemType);
    this.iItemCount= is.readInt32(3, false, this.iItemCount);
    this.lScore= is.readInt64(4, false, this.lScore);
    this.bIsOrder= is.readBoolean(5, false, this.bIsOrder);
    this.iBroadcast= is.readInt32(6, false, this.iBroadcast);
    this.lMicUid= is.readInt64(7, false, this.lMicUid);
};


ActPK.ActPKMemberInfo = function()
{
    this.vAttackers = new Taf.Vector(new ActPK.ActPKMember());
    this.vDefenders = new Taf.Vector(new ActPK.ActPKMember());
};
ActPK.ActPKMemberInfo.prototype._clone = function () { return new ActPK.ActPKMemberInfo(); }
ActPK.ActPKMemberInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKMemberInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKMemberInfo.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vAttackers);
    os.writeVector(1, this.vDefenders);
};

ActPK.ActPKMemberInfo.prototype.readFrom = function (is)
{
    this.vAttackers= is.readVector(0, false, this.vAttackers);
    this.vDefenders= is.readVector(1, false, this.vDefenders);
};


ActPK.ActPKInfo = function()
{
    this.lActId = 0;
    this.lPKId = 0;
    this.iType = 0;
    this.iArea = 0;
    this.lAttPid = 0;
    this.lAttScore = 0;
    this.lDefPid = 0;
    this.lDefScore = 0;
    this.iBeginTime = 0;
    this.iEndTime = 0;
    this.iKillTime = 0;
    this.iState = 0;
    this.lAttReward = 0;
    this.lDefReward = 0;
    this.lFlag = 0;
    this.lFlag2 = 0;
    this.lGameId = 0;
};
ActPK.ActPKInfo.prototype._clone = function () { return new ActPK.ActPKInfo(); }
ActPK.ActPKInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lActId);
    os.writeInt64(1, this.lPKId);
    os.writeInt32(2, this.iType);
    os.writeInt32(3, this.iArea);
    os.writeInt64(4, this.lAttPid);
    os.writeInt64(5, this.lAttScore);
    os.writeInt64(6, this.lDefPid);
    os.writeInt64(7, this.lDefScore);
    os.writeInt32(8, this.iBeginTime);
    os.writeInt32(9, this.iEndTime);
    os.writeInt32(10, this.iKillTime);
    os.writeInt32(11, this.iState);
    os.writeInt64(12, this.lAttReward);
    os.writeInt64(13, this.lDefReward);
    os.writeInt64(14, this.lFlag);
    os.writeInt64(15, this.lFlag2);
    os.writeInt64(16, this.lGameId);
};

ActPK.ActPKInfo.prototype.readFrom = function (is)
{
    this.lActId= is.readInt64(0, false, this.lActId);
    this.lPKId= is.readInt64(1, false, this.lPKId);
    this.iType= is.readInt32(2, false, this.iType);
    this.iArea= is.readInt32(3, false, this.iArea);
    this.lAttPid= is.readInt64(4, false, this.lAttPid);
    this.lAttScore= is.readInt64(5, false, this.lAttScore);
    this.lDefPid= is.readInt64(6, false, this.lDefPid);
    this.lDefScore= is.readInt64(7, false, this.lDefScore);
    this.iBeginTime= is.readInt32(8, false, this.iBeginTime);
    this.iEndTime= is.readInt32(9, false, this.iEndTime);
    this.iKillTime= is.readInt32(10, false, this.iKillTime);
    this.iState= is.readInt32(11, false, this.iState);
    this.lAttReward= is.readInt64(12, false, this.lAttReward);
    this.lDefReward= is.readInt64(13, false, this.lDefReward);
    this.lFlag= is.readInt64(14, false, this.lFlag);
    this.lFlag2= is.readInt64(15, false, this.lFlag2);
    this.lGameId= is.readInt64(16, false, this.lGameId);
};

var ActDocor = ActDocor || {};


ActDocor.GmMessageReq = function()
{
    this.iCmdId = 0;
    this.lUid = 0;
    this.lPid = 0;
    this.sContent = "";
};
ActDocor.GmMessageReq.prototype._clone = function () { return new ActDocor.GmMessageReq(); }
ActDocor.GmMessageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActDocor.GmMessageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActDocor.GmMessageReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCmdId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lPid);
    os.writeString(3, this.sContent);
};

ActDocor.GmMessageReq.prototype.readFrom = function (is)
{
    this.iCmdId= is.readInt32(0, false, this.iCmdId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.sContent= is.readString(3, false, this.sContent);
};

var Act2020AllStar = Act2020AllStar || {};


Act2020AllStar.TemplateURI = 
{
    PushAnchorPanel: 202010101,
    PushAnchorUpdatePanel: 202010102,
    PushHourRank: 202010103,
    PushStageRank: 202010104,
    PushStagePairRank: 202010105,
    PushRivalPanel: 202010106,
    PushPromoteResultPanel: 202010107,
    PushHonorResultPanel: 202010108,
    PushStarIdolRankPanel: 202010109,
    PushBattleAnnouncePanel: 202010121,
    PushBattlePanel: 202010122,
    PushBattleUpdatePanel: 202010123,
    PushBattleFansScorePanel: 202010124,
    PushBattleResultPanel: 202010125,
    PushTaskUpdate: 202010131,
    PushTaskItemUpdate: 202010132,
    PushClearPanel: 202010199
};

Act2020AllStar.STAGE = 
{
    kBeforeActivityStage: 0,
    kAuditionStage1: 1,
    kAuditionStage2: 2,
    kTop20Stage1: 3,
    kTop20Stage2: 4,
    kTop8Stage: 5,
    kFinalStage1: 6,
    kFinalStage2: 7,
    kHonorStage: 8
};

Act2020AllStar.PromoteType = 
{
    PT_Promote: 1,
    PT_Eliminate: 2
};

Act2020AllStar.CType = 
{
    E_CType_Content: 1,
    E_CType_Pic: 2
};

Act2020AllStar.TaskLevel = 
{
    E_TaskLevel_B: 1,
    E_TaskLevel_A: 2,
    E_TaskLevel_S: 3,
    E_TaskLevel_SS: 4
};

Act2020AllStar.TaskState = 
{
    E_TaskState_Doing: 0,
    E_TaskState_Done: 1
};

Act2020AllStar.TaskId = 
{
    E_TaskId_PK: 1000,
    E_TaskId_SendFTNum: 1001,
    E_TaskId_Send666FT: 1002,
    E_TaskId_AddFans: 1003,
    E_TaskId_SendHeartNum: 1004,
    E_TaskId_SAnniversary: 1005
};

Act2020AllStar.JumpChannel = function()
{
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iGameId = 0;
    this.lYYId = 0;
    this.iRoomId = 0;
    this.bIsLive = true;
};
Act2020AllStar.JumpChannel.prototype._clone = function () { return new Act2020AllStar.JumpChannel(); }
Act2020AllStar.JumpChannel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.JumpChannel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.JumpChannel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeInt32(3, this.iGameId);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iRoomId);
    os.writeBoolean(6, this.bIsLive);
};

Act2020AllStar.JumpChannel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.iGameId= is.readInt32(3, false, this.iGameId);
    this.lYYId= is.readInt64(4, false, this.lYYId);
    this.iRoomId= is.readInt32(5, false, this.iRoomId);
    this.bIsLive= is.readBoolean(6, false, this.bIsLive);
};

Act2020AllStar.AnchorUpdatePanel = function()
{
    this.lPid = 0;
    this.iRank = 0;
    this.lScore = 0;
    this.iHourRank = 0;
    this.lHourScore = 0;
    this.iBuff = 0;
    this.iPromote = 0;
    this.iPromotStatus = 0;
    this.iUnionPromoteLimit = 0;
};
Act2020AllStar.AnchorUpdatePanel.prototype._clone = function () { return new Act2020AllStar.AnchorUpdatePanel(); }
Act2020AllStar.AnchorUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AnchorUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AnchorUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeInt32(3, this.iHourRank);
    os.writeInt64(4, this.lHourScore);
    os.writeInt32(5, this.iBuff);
    os.writeInt32(6, this.iPromote);
    os.writeInt32(7, this.iPromotStatus);
    os.writeInt32(8, this.iUnionPromoteLimit);
};

Act2020AllStar.AnchorUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.iHourRank= is.readInt32(3, false, this.iHourRank);
    this.lHourScore= is.readInt64(4, false, this.lHourScore);
    this.iBuff= is.readInt32(5, false, this.iBuff);
    this.iPromote= is.readInt32(6, false, this.iPromote);
    this.iPromotStatus= is.readInt32(7, false, this.iPromotStatus);
    this.iUnionPromoteLimit= is.readInt32(8, false, this.iUnionPromoteLimit);
};

Act2020AllStar.AnchorPanel = function()
{
    this.tUpdate = new Act2020AllStar.AnchorUpdatePanel();
    this.iCurDay = 0;
    this.iMaxDay = 0;
    this.iStage = 0;
    this.sStageName = "";
    this.iArea = 0;
    this.iSubArea = 0;
    this.sSubAreaName = "";
    this.sNickName = "";
    this.sLogoUrl = "";
    this.sPromoreDesc = "";
    this.iPromoteNum = 0;
    this.iStarIdol = 0;
    this.sPortraitUrl = "";
};
Act2020AllStar.AnchorPanel.prototype._clone = function () { return new Act2020AllStar.AnchorPanel(); }
Act2020AllStar.AnchorPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AnchorPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AnchorPanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUpdate);
    os.writeInt32(1, this.iCurDay);
    os.writeInt32(2, this.iMaxDay);
    os.writeInt32(3, this.iStage);
    os.writeString(4, this.sStageName);
    os.writeInt32(5, this.iArea);
    os.writeInt32(6, this.iSubArea);
    os.writeString(7, this.sSubAreaName);
    os.writeString(8, this.sNickName);
    os.writeString(9, this.sLogoUrl);
    os.writeString(10, this.sPromoreDesc);
    os.writeInt32(11, this.iPromoteNum);
    os.writeInt32(12, this.iStarIdol);
    os.writeString(13, this.sPortraitUrl);
};

Act2020AllStar.AnchorPanel.prototype.readFrom = function (is)
{
    this.tUpdate= is.readStruct(0, false, this.tUpdate);
    this.iCurDay= is.readInt32(1, false, this.iCurDay);
    this.iMaxDay= is.readInt32(2, false, this.iMaxDay);
    this.iStage= is.readInt32(3, false, this.iStage);
    this.sStageName= is.readString(4, false, this.sStageName);
    this.iArea= is.readInt32(5, false, this.iArea);
    this.iSubArea= is.readInt32(6, false, this.iSubArea);
    this.sSubAreaName= is.readString(7, false, this.sSubAreaName);
    this.sNickName= is.readString(8, false, this.sNickName);
    this.sLogoUrl= is.readString(9, false, this.sLogoUrl);
    this.sPromoreDesc= is.readString(10, false, this.sPromoreDesc);
    this.iPromoteNum= is.readInt32(11, false, this.iPromoteNum);
    this.iStarIdol= is.readInt32(12, false, this.iStarIdol);
    this.sPortraitUrl= is.readString(13, false, this.sPortraitUrl);
};

Act2020AllStar.RankItem = function()
{
    this.tJump = new Act2020AllStar.JumpChannel();
    this.iRank = 0;
    this.lScore = 0;
    this.iPromoteStatus = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.sDesc = "";
    this.iStarIdol = 0;
    this.sPortraitUrl = "";
};
Act2020AllStar.RankItem.prototype._clone = function () { return new Act2020AllStar.RankItem(); }
Act2020AllStar.RankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RankItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tJump);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeInt32(3, this.iPromoteStatus);
    os.writeString(4, this.sNickName);
    os.writeString(5, this.sLogoUrl);
    os.writeString(6, this.sDesc);
    os.writeInt32(7, this.iStarIdol);
    os.writeString(8, this.sPortraitUrl);
};

Act2020AllStar.RankItem.prototype.readFrom = function (is)
{
    this.tJump= is.readStruct(0, false, this.tJump);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.iPromoteStatus= is.readInt32(3, false, this.iPromoteStatus);
    this.sNickName= is.readString(4, false, this.sNickName);
    this.sLogoUrl= is.readString(5, false, this.sLogoUrl);
    this.sDesc= is.readString(6, false, this.sDesc);
    this.iStarIdol= is.readInt32(7, false, this.iStarIdol);
    this.sPortraitUrl= is.readString(8, false, this.sPortraitUrl);
};

Act2020AllStar.HourRankPanel = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.iHour = 0;
    this.vRankList = new Taf.Vector(new Act2020AllStar.RankItem());
};
Act2020AllStar.HourRankPanel.prototype._clone = function () { return new Act2020AllStar.HourRankPanel(); }
Act2020AllStar.HourRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HourRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HourRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeInt32(2, this.iHour);
    os.writeVector(3, this.vRankList);
};

Act2020AllStar.HourRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.iHour= is.readInt32(2, false, this.iHour);
    this.vRankList= is.readVector(3, false, this.vRankList);
};

Act2020AllStar.StageRankPanel = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.vRankList = new Taf.Vector(new Act2020AllStar.RankItem());
};
Act2020AllStar.StageRankPanel.prototype._clone = function () { return new Act2020AllStar.StageRankPanel(); }
Act2020AllStar.StageRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.StageRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.StageRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeVector(2, this.vRankList);
};

Act2020AllStar.StageRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.vRankList= is.readVector(2, false, this.vRankList);
};

Act2020AllStar.PairRankItem = function()
{
    this.tLeftItem = new Act2020AllStar.RankItem();
    this.tRightItem = new Act2020AllStar.RankItem();
};
Act2020AllStar.PairRankItem.prototype._clone = function () { return new Act2020AllStar.PairRankItem(); }
Act2020AllStar.PairRankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.PairRankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.PairRankItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tLeftItem);
    os.writeStruct(1, this.tRightItem);
};

Act2020AllStar.PairRankItem.prototype.readFrom = function (is)
{
    this.tLeftItem= is.readStruct(0, false, this.tLeftItem);
    this.tRightItem= is.readStruct(1, false, this.tRightItem);
};

Act2020AllStar.StagePairRankPanel = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.vRankList = new Taf.Vector(new Act2020AllStar.PairRankItem());
};
Act2020AllStar.StagePairRankPanel.prototype._clone = function () { return new Act2020AllStar.StagePairRankPanel(); }
Act2020AllStar.StagePairRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.StagePairRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.StagePairRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeVector(2, this.vRankList);
};

Act2020AllStar.StagePairRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.vRankList= is.readVector(2, false, this.vRankList);
};

Act2020AllStar.RivalPanel = function()
{
    this.tJump = new Act2020AllStar.JumpChannel();
    this.lPid = 0;
    this.lScore = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
};
Act2020AllStar.RivalPanel.prototype._clone = function () { return new Act2020AllStar.RivalPanel(); }
Act2020AllStar.RivalPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RivalPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RivalPanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tJump);
    os.writeInt64(1, this.lPid);
    os.writeInt64(2, this.lScore);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sLogoUrl);
};

Act2020AllStar.RivalPanel.prototype.readFrom = function (is)
{
    this.tJump= is.readStruct(0, false, this.tJump);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sLogoUrl= is.readString(4, false, this.sLogoUrl);
};

Act2020AllStar.StarIdolRankPanel = function()
{
    this.iAreaId = 0;
    this.vRankList = new Taf.Vector(new Act2020AllStar.RankItem());
};
Act2020AllStar.StarIdolRankPanel.prototype._clone = function () { return new Act2020AllStar.StarIdolRankPanel(); }
Act2020AllStar.StarIdolRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.StarIdolRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.StarIdolRankPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeVector(1, this.vRankList);
};

Act2020AllStar.StarIdolRankPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.vRankList= is.readVector(1, false, this.vRankList);
};

Act2020AllStar.PromoteResultPanel = function()
{
    this.lPid = 0;
    this.iPromoteType = 0;
    this.iAreaId = 0;
    this.sSubAreaName = "";
    this.sDesc = "";
    this.sNickName = "";
    this.sLogoUrl = "";
    this.iStarIdol = 0;
    this.sPortraitUrl = "";
    this.sDesc2 = "";
};
Act2020AllStar.PromoteResultPanel.prototype._clone = function () { return new Act2020AllStar.PromoteResultPanel(); }
Act2020AllStar.PromoteResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.PromoteResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.PromoteResultPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iPromoteType);
    os.writeInt32(2, this.iAreaId);
    os.writeString(3, this.sSubAreaName);
    os.writeString(4, this.sDesc);
    os.writeString(5, this.sNickName);
    os.writeString(6, this.sLogoUrl);
    os.writeInt32(7, this.iStarIdol);
    os.writeString(8, this.sPortraitUrl);
    os.writeString(9, this.sDesc2);
};

Act2020AllStar.PromoteResultPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iPromoteType= is.readInt32(1, false, this.iPromoteType);
    this.iAreaId= is.readInt32(2, false, this.iAreaId);
    this.sSubAreaName= is.readString(3, false, this.sSubAreaName);
    this.sDesc= is.readString(4, false, this.sDesc);
    this.sNickName= is.readString(5, false, this.sNickName);
    this.sLogoUrl= is.readString(6, false, this.sLogoUrl);
    this.iStarIdol= is.readInt32(7, false, this.iStarIdol);
    this.sPortraitUrl= is.readString(8, false, this.sPortraitUrl);
    this.sDesc2= is.readString(9, false, this.sDesc2);
};

Act2020AllStar.PresenterInfo = function()
{
    this.lPid = 0;
    this.iRank = 0;
    this.sLogoUrl = "";
    this.sNickName = "";
    this.tJump = new Act2020AllStar.JumpChannel();
    this.iStarIdol = 0;
    this.sPortraitUrl = "";
};
Act2020AllStar.PresenterInfo.prototype._clone = function () { return new Act2020AllStar.PresenterInfo(); }
Act2020AllStar.PresenterInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.PresenterInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.PresenterInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iRank);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sNickName);
    os.writeStruct(4, this.tJump);
    os.writeInt32(5, this.iStarIdol);
    os.writeString(6, this.sPortraitUrl);
};

Act2020AllStar.PresenterInfo.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.tJump= is.readStruct(4, false, this.tJump);
    this.iStarIdol= is.readInt32(5, false, this.iStarIdol);
    this.sPortraitUrl= is.readString(6, false, this.sPortraitUrl);
};

Act2020AllStar.HonorResultPanel = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.sSubAreaName = "";
    this.vWinnerList = new Taf.Vector(new Act2020AllStar.PresenterInfo());
    this.iStarIdol = 0;
};
Act2020AllStar.HonorResultPanel.prototype._clone = function () { return new Act2020AllStar.HonorResultPanel(); }
Act2020AllStar.HonorResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HonorResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HonorResultPanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeString(2, this.sSubAreaName);
    os.writeVector(3, this.vWinnerList);
    os.writeInt32(4, this.iStarIdol);
};

Act2020AllStar.HonorResultPanel.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.sSubAreaName= is.readString(2, false, this.sSubAreaName);
    this.vWinnerList= is.readVector(3, false, this.vWinnerList);
    this.iStarIdol= is.readInt32(4, false, this.iStarIdol);
};

Act2020AllStar.ClearPanel = function()
{
    this.lPid = 0;
    this.iActivityId = 0;
};
Act2020AllStar.ClearPanel.prototype._clone = function () { return new Act2020AllStar.ClearPanel(); }
Act2020AllStar.ClearPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.ClearPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.ClearPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iActivityId);
};

Act2020AllStar.ClearPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
};

Act2020AllStar.PkUserInfo = function()
{
    this.tJump = new Act2020AllStar.JumpChannel();
    this.sNickName = "";
    this.sLogoUrl = "";
    this.iPkBuff = 0;
    this.lScore = 0;
};
Act2020AllStar.PkUserInfo.prototype._clone = function () { return new Act2020AllStar.PkUserInfo(); }
Act2020AllStar.PkUserInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.PkUserInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.PkUserInfo.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tJump);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeInt32(3, this.iPkBuff);
    os.writeInt64(4, this.lScore);
};

Act2020AllStar.PkUserInfo.prototype.readFrom = function (is)
{
    this.tJump= is.readStruct(0, false, this.tJump);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.iPkBuff= is.readInt32(3, false, this.iPkBuff);
    this.lScore= is.readInt64(4, false, this.lScore);
};

Act2020AllStar.FansScore = function()
{
    this.sNickName = "";
    this.lScore = 0;
};
Act2020AllStar.FansScore.prototype._clone = function () { return new Act2020AllStar.FansScore(); }
Act2020AllStar.FansScore.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.FansScore.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.FansScore.prototype.writeTo = function (os)
{
    os.writeString(0, this.sNickName);
    os.writeInt64(1, this.lScore);
};

Act2020AllStar.FansScore.prototype.readFrom = function (is)
{
    this.sNickName= is.readString(0, false, this.sNickName);
    this.lScore= is.readInt64(1, false, this.lScore);
};

Act2020AllStar.BattleFansScorePanel = function()
{
    this.lPid = 0;
    this.vAttFansScore = new Taf.Vector(new Act2020AllStar.FansScore());
    this.vDefFansScore = new Taf.Vector(new Act2020AllStar.FansScore());
};
Act2020AllStar.BattleFansScorePanel.prototype._clone = function () { return new Act2020AllStar.BattleFansScorePanel(); }
Act2020AllStar.BattleFansScorePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.BattleFansScorePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.BattleFansScorePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeVector(1, this.vAttFansScore);
    os.writeVector(2, this.vDefFansScore);
};

Act2020AllStar.BattleFansScorePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.vAttFansScore= is.readVector(1, false, this.vAttFansScore);
    this.vDefFansScore= is.readVector(2, false, this.vDefFansScore);
};

Act2020AllStar.BattleUpdatePanel = function()
{
    this.lPid = 0;
    this.iSide = 0;
    this.iLeftTime = 0;
    this.iKillTime = 0;
    this.lAttScore = 0;
    this.lDefScore = 0;
};
Act2020AllStar.BattleUpdatePanel.prototype._clone = function () { return new Act2020AllStar.BattleUpdatePanel(); }
Act2020AllStar.BattleUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.BattleUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.BattleUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iSide);
    os.writeInt32(2, this.iLeftTime);
    os.writeInt32(3, this.iKillTime);
    os.writeInt64(4, this.lAttScore);
    os.writeInt64(5, this.lDefScore);
};

Act2020AllStar.BattleUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iSide= is.readInt32(1, false, this.iSide);
    this.iLeftTime= is.readInt32(2, false, this.iLeftTime);
    this.iKillTime= is.readInt32(3, false, this.iKillTime);
    this.lAttScore= is.readInt64(4, false, this.lAttScore);
    this.lDefScore= is.readInt64(5, false, this.lDefScore);
};

Act2020AllStar.BattlePanel = function()
{
    this.iPkType = 0;
    this.tAttUser = new Act2020AllStar.PkUserInfo();
    this.tDefUser = new Act2020AllStar.PkUserInfo();
    this.tUpdateScore = new Act2020AllStar.BattleUpdatePanel();
    this.iAreaId = 0;
};
Act2020AllStar.BattlePanel.prototype._clone = function () { return new Act2020AllStar.BattlePanel(); }
Act2020AllStar.BattlePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.BattlePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.BattlePanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iPkType);
    os.writeStruct(1, this.tAttUser);
    os.writeStruct(2, this.tDefUser);
    os.writeStruct(3, this.tUpdateScore);
    os.writeInt32(4, this.iAreaId);
};

Act2020AllStar.BattlePanel.prototype.readFrom = function (is)
{
    this.iPkType= is.readInt32(0, false, this.iPkType);
    this.tAttUser= is.readStruct(1, false, this.tAttUser);
    this.tDefUser= is.readStruct(2, false, this.tDefUser);
    this.tUpdateScore= is.readStruct(3, false, this.tUpdateScore);
    this.iAreaId= is.readInt32(4, false, this.iAreaId);
};

Act2020AllStar.BattleAnnouncePanel = function()
{
    this.tBattle = new Act2020AllStar.BattlePanel();
    this.iBuffButton = 0;
};
Act2020AllStar.BattleAnnouncePanel.prototype._clone = function () { return new Act2020AllStar.BattleAnnouncePanel(); }
Act2020AllStar.BattleAnnouncePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.BattleAnnouncePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.BattleAnnouncePanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iBuffButton);
};

Act2020AllStar.BattleAnnouncePanel.prototype.readFrom = function (is)
{
    this.tBattle= is.readStruct(0, false, this.tBattle);
    this.iBuffButton= is.readInt32(1, false, this.iBuffButton);
};

Act2020AllStar.BattleResultPanel = function()
{
    this.tBattle = new Act2020AllStar.BattlePanel();
    this.iResult = 0;
    this.lDeltaScore = 0;
    this.lReturnScore = 0;
};
Act2020AllStar.BattleResultPanel.prototype._clone = function () { return new Act2020AllStar.BattleResultPanel(); }
Act2020AllStar.BattleResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.BattleResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.BattleResultPanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iResult);
    os.writeInt64(2, this.lDeltaScore);
    os.writeInt64(3, this.lReturnScore);
};

Act2020AllStar.BattleResultPanel.prototype.readFrom = function (is)
{
    this.tBattle= is.readStruct(0, false, this.tBattle);
    this.iResult= is.readInt32(1, false, this.iResult);
    this.lDeltaScore= is.readInt64(2, false, this.lDeltaScore);
    this.lReturnScore= is.readInt64(3, false, this.lReturnScore);
};

Act2020AllStar.AttackReq = function()
{
    this.tAttackId = new HUYA.UserId();
    this.lDefPid = 0;
};
Act2020AllStar.AttackReq.prototype._clone = function () { return new Act2020AllStar.AttackReq(); }
Act2020AllStar.AttackReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AttackReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AttackReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tAttackId);
    os.writeInt64(1, this.lDefPid);
};

Act2020AllStar.AttackReq.prototype.readFrom = function (is)
{
    this.tAttackId= is.readStruct(0, false, this.tAttackId);
    this.lDefPid= is.readInt64(1, false, this.lDefPid);
};

Act2020AllStar.AttackRsp = function()
{
    this.iResult = 0;
    this.lAttPid = 0;
    this.lDefPid = 0;
    this.sDesc1 = "";
    this.sDesc2 = "";
};
Act2020AllStar.AttackRsp.prototype._clone = function () { return new Act2020AllStar.AttackRsp(); }
Act2020AllStar.AttackRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AttackRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AttackRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeInt64(1, this.lAttPid);
    os.writeInt64(2, this.lDefPid);
    os.writeString(3, this.sDesc1);
    os.writeString(4, this.sDesc2);
};

Act2020AllStar.AttackRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.lAttPid= is.readInt64(1, false, this.lAttPid);
    this.lDefPid= is.readInt64(2, false, this.lDefPid);
    this.sDesc1= is.readString(3, false, this.sDesc1);
    this.sDesc2= is.readString(4, false, this.sDesc2);
};

Act2020AllStar.AttackSearchItem = function()
{
    this.lPid = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.lScore = 0;
    this.iAttTime = 0;
    this.iDefTime = 0;
    this.bRevege = true;
};
Act2020AllStar.AttackSearchItem.prototype._clone = function () { return new Act2020AllStar.AttackSearchItem(); }
Act2020AllStar.AttackSearchItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AttackSearchItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AttackSearchItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeInt64(3, this.lScore);
    os.writeInt32(4, this.iAttTime);
    os.writeInt32(5, this.iDefTime);
    os.writeBoolean(6, this.bRevege);
};

Act2020AllStar.AttackSearchItem.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.lScore= is.readInt64(3, false, this.lScore);
    this.iAttTime= is.readInt32(4, false, this.iAttTime);
    this.iDefTime= is.readInt32(5, false, this.iDefTime);
    this.bRevege= is.readBoolean(6, false, this.bRevege);
};

Act2020AllStar.AttackSearchReq = function()
{
    this.lPid = 0;
    this.sSearchName = "";
};
Act2020AllStar.AttackSearchReq.prototype._clone = function () { return new Act2020AllStar.AttackSearchReq(); }
Act2020AllStar.AttackSearchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AttackSearchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AttackSearchReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sSearchName);
};

Act2020AllStar.AttackSearchReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sSearchName= is.readString(1, false, this.sSearchName);
};

Act2020AllStar.AttackSearchRsp = function()
{
    this.vItems = new Taf.Vector(new Act2020AllStar.AttackSearchItem());
};
Act2020AllStar.AttackSearchRsp.prototype._clone = function () { return new Act2020AllStar.AttackSearchRsp(); }
Act2020AllStar.AttackSearchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AttackSearchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AttackSearchRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItems);
};

Act2020AllStar.AttackSearchRsp.prototype.readFrom = function (is)
{
    this.vItems= is.readVector(0, false, this.vItems);
};

Act2020AllStar.EnablePkBuffReq = function()
{
    this.tPid = new HUYA.UserId();
};
Act2020AllStar.EnablePkBuffReq.prototype._clone = function () { return new Act2020AllStar.EnablePkBuffReq(); }
Act2020AllStar.EnablePkBuffReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.EnablePkBuffReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.EnablePkBuffReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPid);
};

Act2020AllStar.EnablePkBuffReq.prototype.readFrom = function (is)
{
    this.tPid= is.readStruct(0, false, this.tPid);
};

Act2020AllStar.EnablePkBuffRsp = function()
{
    this.iRet = 0;
    this.sErrMsg = "";
};
Act2020AllStar.EnablePkBuffRsp.prototype._clone = function () { return new Act2020AllStar.EnablePkBuffRsp(); }
Act2020AllStar.EnablePkBuffRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.EnablePkBuffRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.EnablePkBuffRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sErrMsg);
};

Act2020AllStar.EnablePkBuffRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sErrMsg= is.readString(1, false, this.sErrMsg);
};

Act2020AllStar.Context = function()
{
    this.sWord = "";
    this.iColor = 0;
    this.iContextType = 0;
};
Act2020AllStar.Context.prototype._clone = function () { return new Act2020AllStar.Context(); }
Act2020AllStar.Context.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.Context.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.Context.prototype.writeTo = function (os)
{
    os.writeString(0, this.sWord);
    os.writeInt32(1, this.iColor);
    os.writeInt32(2, this.iContextType);
};

Act2020AllStar.Context.prototype.readFrom = function (is)
{
    this.sWord= is.readString(0, false, this.sWord);
    this.iColor= is.readInt32(1, false, this.iColor);
    this.iContextType= is.readInt32(2, false, this.iContextType);
};

Act2020AllStar.UserTaskState = function()
{
    this.lTaskId = 0;
    this.sTaskDesc = "";
    this.iState = 0;
    this.iTaskLevel = 0;
    this.iNowExperience = 0;
    this.iNextExperience = 0;
};
Act2020AllStar.UserTaskState.prototype._clone = function () { return new Act2020AllStar.UserTaskState(); }
Act2020AllStar.UserTaskState.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.UserTaskState.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.UserTaskState.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTaskId);
    os.writeString(1, this.sTaskDesc);
    os.writeInt32(2, this.iState);
    os.writeInt32(3, this.iTaskLevel);
    os.writeInt32(4, this.iNowExperience);
    os.writeInt32(5, this.iNextExperience);
};

Act2020AllStar.UserTaskState.prototype.readFrom = function (is)
{
    this.lTaskId= is.readInt64(0, false, this.lTaskId);
    this.sTaskDesc= is.readString(1, false, this.sTaskDesc);
    this.iState= is.readInt32(2, false, this.iState);
    this.iTaskLevel= is.readInt32(3, false, this.iTaskLevel);
    this.iNowExperience= is.readInt32(4, false, this.iNowExperience);
    this.iNextExperience= is.readInt32(5, false, this.iNextExperience);
};

Act2020AllStar.TaskUpdatePanel = function()
{
    this.lPid = 0;
    this.lTopTaskId = 0;
    this.vTaskList = new Taf.Vector(new Act2020AllStar.UserTaskState());
    this.mpFinshedNum = new Taf.Map(new Taf.INT32(), new Taf.INT32());
    this.vAward = new Taf.Vector(new Act2020AllStar.Context());
};
Act2020AllStar.TaskUpdatePanel.prototype._clone = function () { return new Act2020AllStar.TaskUpdatePanel(); }
Act2020AllStar.TaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.TaskUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.TaskUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTopTaskId);
    os.writeVector(2, this.vTaskList);
    os.writeMap(3, this.mpFinshedNum);
    os.writeVector(4, this.vAward);
};

Act2020AllStar.TaskUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTopTaskId= is.readInt64(1, false, this.lTopTaskId);
    this.vTaskList= is.readVector(2, false, this.vTaskList);
    this.mpFinshedNum= is.readMap(3, false, this.mpFinshedNum);
    this.vAward= is.readVector(4, false, this.vAward);
};

Act2020AllStar.SingleTaskUpdatePanel = function()
{
    this.lPid = 0;
    this.tTaskItem = new Act2020AllStar.UserTaskState();
};
Act2020AllStar.SingleTaskUpdatePanel.prototype._clone = function () { return new Act2020AllStar.SingleTaskUpdatePanel(); }
Act2020AllStar.SingleTaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.SingleTaskUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.SingleTaskUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeStruct(1, this.tTaskItem);
};

Act2020AllStar.SingleTaskUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.tTaskItem= is.readStruct(1, false, this.tTaskItem);
};

Act2020AllStar.TopTaskReq = function()
{
    this.lPid = 0;
    this.lTaskId = 0;
};
Act2020AllStar.TopTaskReq.prototype._clone = function () { return new Act2020AllStar.TopTaskReq(); }
Act2020AllStar.TopTaskReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.TopTaskReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.TopTaskReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTaskId);
};

Act2020AllStar.TopTaskReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTaskId= is.readInt64(1, false, this.lTaskId);
};

Act2020AllStar.TopTaskRsp = function()
{
    this.iRet = 0;
    this.sMsg = "";
    this.tUserTaskState = new Act2020AllStar.UserTaskState();
};
Act2020AllStar.TopTaskRsp.prototype._clone = function () { return new Act2020AllStar.TopTaskRsp(); }
Act2020AllStar.TopTaskRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.TopTaskRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.TopTaskRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sMsg);
    os.writeStruct(2, this.tUserTaskState);
};

Act2020AllStar.TopTaskRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sMsg= is.readString(1, false, this.sMsg);
    this.tUserTaskState= is.readStruct(2, false, this.tUserTaskState);
};

Act2020AllStar.AreaInfo = function()
{
    this.iSubAreaId = 0;
    this.sAreaName = "";
    this.iState = 0;
};
Act2020AllStar.AreaInfo.prototype._clone = function () { return new Act2020AllStar.AreaInfo(); }
Act2020AllStar.AreaInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AreaInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AreaInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iSubAreaId);
    os.writeString(1, this.sAreaName);
    os.writeInt32(2, this.iState);
};

Act2020AllStar.AreaInfo.prototype.readFrom = function (is)
{
    this.iSubAreaId= is.readInt32(0, false, this.iSubAreaId);
    this.sAreaName= is.readString(1, false, this.sAreaName);
    this.iState= is.readInt32(2, false, this.iState);
};

Act2020AllStar.RegisterStateReq = function()
{
    this.lPid = 0;
};
Act2020AllStar.RegisterStateReq.prototype._clone = function () { return new Act2020AllStar.RegisterStateReq(); }
Act2020AllStar.RegisterStateReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RegisterStateReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RegisterStateReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
};

Act2020AllStar.RegisterStateReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
};

Act2020AllStar.RegisterStateRsp = function()
{
    this.iAreaId = 0;
    this.tInfo = new Act2020AllStar.AreaInfo();
};
Act2020AllStar.RegisterStateRsp.prototype._clone = function () { return new Act2020AllStar.RegisterStateRsp(); }
Act2020AllStar.RegisterStateRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RegisterStateRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RegisterStateRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeStruct(1, this.tInfo);
};

Act2020AllStar.RegisterStateRsp.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.tInfo= is.readStruct(1, false, this.tInfo);
};

Act2020AllStar.AreaInfoReq = function()
{
    this.lPid = 0;
};
Act2020AllStar.AreaInfoReq.prototype._clone = function () { return new Act2020AllStar.AreaInfoReq(); }
Act2020AllStar.AreaInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AreaInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AreaInfoReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
};

Act2020AllStar.AreaInfoReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
};

Act2020AllStar.AreaInfoRsp = function()
{
    this.vGameArea = new Taf.Vector(new Act2020AllStar.AreaInfo());
    this.vEntArea = new Taf.Vector(new Act2020AllStar.AreaInfo());
};
Act2020AllStar.AreaInfoRsp.prototype._clone = function () { return new Act2020AllStar.AreaInfoRsp(); }
Act2020AllStar.AreaInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AreaInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AreaInfoRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vGameArea);
    os.writeVector(1, this.vEntArea);
};

Act2020AllStar.AreaInfoRsp.prototype.readFrom = function (is)
{
    this.vGameArea= is.readVector(0, false, this.vGameArea);
    this.vEntArea= is.readVector(1, false, this.vEntArea);
};

Act2020AllStar.RegisterReq = function()
{
    this.lPid = 0;
    this.iAreaId = 0;
    this.iSubAreaId = 0;
};
Act2020AllStar.RegisterReq.prototype._clone = function () { return new Act2020AllStar.RegisterReq(); }
Act2020AllStar.RegisterReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RegisterReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RegisterReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iAreaId);
    os.writeInt32(2, this.iSubAreaId);
};

Act2020AllStar.RegisterReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iAreaId= is.readInt32(1, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(2, false, this.iSubAreaId);
};

Act2020AllStar.RegisterRsp = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.iRes = 0;
    this.sDesc = "";
};
Act2020AllStar.RegisterRsp.prototype._clone = function () { return new Act2020AllStar.RegisterRsp(); }
Act2020AllStar.RegisterRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RegisterRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RegisterRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeInt32(2, this.iRes);
    os.writeString(3, this.sDesc);
};

Act2020AllStar.RegisterRsp.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.iRes= is.readInt32(2, false, this.iRes);
    this.sDesc= is.readString(3, false, this.sDesc);
};

Act2020AllStar.StageInfoReq = function()
{
    this.lPid = 0;
};
Act2020AllStar.StageInfoReq.prototype._clone = function () { return new Act2020AllStar.StageInfoReq(); }
Act2020AllStar.StageInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.StageInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.StageInfoReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
};

Act2020AllStar.StageInfoReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
};

Act2020AllStar.StageInfoRsp = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.iEntStage = 0;
    this.iGameStage = 0;
    this.sAreaName = "";
};
Act2020AllStar.StageInfoRsp.prototype._clone = function () { return new Act2020AllStar.StageInfoRsp(); }
Act2020AllStar.StageInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.StageInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.StageInfoRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeInt32(2, this.iEntStage);
    os.writeInt32(3, this.iGameStage);
    os.writeString(4, this.sAreaName);
};

Act2020AllStar.StageInfoRsp.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.iEntStage= is.readInt32(2, false, this.iEntStage);
    this.iGameStage= is.readInt32(3, false, this.iGameStage);
    this.sAreaName= is.readString(4, false, this.sAreaName);
};

Act2020AllStar.RichRankReq = function()
{
    this.iAreaId = 0;
};
Act2020AllStar.RichRankReq.prototype._clone = function () { return new Act2020AllStar.RichRankReq(); }
Act2020AllStar.RichRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RichRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RichRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
};

Act2020AllStar.RichRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
};

Act2020AllStar.RichRankRsp = function()
{
    this.tPanel = new Act2020AllStar.StageRankPanel();
};
Act2020AllStar.RichRankRsp.prototype._clone = function () { return new Act2020AllStar.RichRankRsp(); }
Act2020AllStar.RichRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RichRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RichRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanel);
};

Act2020AllStar.RichRankRsp.prototype.readFrom = function (is)
{
    this.tPanel= is.readStruct(0, false, this.tPanel);
};

Act2020AllStar.AuditionRankReq = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.lPid = 0;
};
Act2020AllStar.AuditionRankReq.prototype._clone = function () { return new Act2020AllStar.AuditionRankReq(); }
Act2020AllStar.AuditionRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AuditionRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AuditionRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeInt64(2, this.lPid);
};

Act2020AllStar.AuditionRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.lPid= is.readInt64(2, false, this.lPid);
};

Act2020AllStar.AuditionRankRsp = function()
{
    this.tPanel = new Act2020AllStar.StageRankPanel();
    this.sDesc = "";
    this.tItem = new Act2020AllStar.RankItem();
};
Act2020AllStar.AuditionRankRsp.prototype._clone = function () { return new Act2020AllStar.AuditionRankRsp(); }
Act2020AllStar.AuditionRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.AuditionRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.AuditionRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanel);
    os.writeString(1, this.sDesc);
    os.writeStruct(2, this.tItem);
};

Act2020AllStar.AuditionRankRsp.prototype.readFrom = function (is)
{
    this.tPanel= is.readStruct(0, false, this.tPanel);
    this.sDesc= is.readString(1, false, this.sDesc);
    this.tItem= is.readStruct(2, false, this.tItem);
};

Act2020AllStar.EliminateRankReq = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
};
Act2020AllStar.EliminateRankReq.prototype._clone = function () { return new Act2020AllStar.EliminateRankReq(); }
Act2020AllStar.EliminateRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.EliminateRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.EliminateRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
};

Act2020AllStar.EliminateRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
};

Act2020AllStar.EliminateRankRsp = function()
{
    this.tPanelA = new Act2020AllStar.StageRankPanel();
    this.tPanelB = new Act2020AllStar.StageRankPanel();
    this.sDescA = "";
    this.sDescB = "";
};
Act2020AllStar.EliminateRankRsp.prototype._clone = function () { return new Act2020AllStar.EliminateRankRsp(); }
Act2020AllStar.EliminateRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.EliminateRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.EliminateRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanelA);
    os.writeStruct(1, this.tPanelB);
    os.writeString(2, this.sDescA);
    os.writeString(3, this.sDescB);
};

Act2020AllStar.EliminateRankRsp.prototype.readFrom = function (is)
{
    this.tPanelA= is.readStruct(0, false, this.tPanelA);
    this.tPanelB= is.readStruct(1, false, this.tPanelB);
    this.sDescA= is.readString(2, false, this.sDescA);
    this.sDescB= is.readString(3, false, this.sDescB);
};

Act2020AllStar.RingRankReq = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
};
Act2020AllStar.RingRankReq.prototype._clone = function () { return new Act2020AllStar.RingRankReq(); }
Act2020AllStar.RingRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RingRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RingRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
};

Act2020AllStar.RingRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
};

Act2020AllStar.RingRankRsp = function()
{
    this.tPanel = new Act2020AllStar.StagePairRankPanel();
    this.tLoser = new Act2020AllStar.StageRankPanel();
};
Act2020AllStar.RingRankRsp.prototype._clone = function () { return new Act2020AllStar.RingRankRsp(); }
Act2020AllStar.RingRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.RingRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.RingRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanel);
    os.writeStruct(1, this.tLoser);
};

Act2020AllStar.RingRankRsp.prototype.readFrom = function (is)
{
    this.tPanel= is.readStruct(0, false, this.tPanel);
    this.tLoser= is.readStruct(1, false, this.tLoser);
};

Act2020AllStar.FinalRankReq = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
};
Act2020AllStar.FinalRankReq.prototype._clone = function () { return new Act2020AllStar.FinalRankReq(); }
Act2020AllStar.FinalRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.FinalRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.FinalRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
};

Act2020AllStar.FinalRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
};

Act2020AllStar.FinalRankRsp = function()
{
    this.tPanel = new Act2020AllStar.StageRankPanel();
    this.sDesc = "";
};
Act2020AllStar.FinalRankRsp.prototype._clone = function () { return new Act2020AllStar.FinalRankRsp(); }
Act2020AllStar.FinalRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.FinalRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.FinalRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanel);
    os.writeString(1, this.sDesc);
};

Act2020AllStar.FinalRankRsp.prototype.readFrom = function (is)
{
    this.tPanel= is.readStruct(0, false, this.tPanel);
    this.sDesc= is.readString(1, false, this.sDesc);
};

Act2020AllStar.TopRankReq = function()
{
    this.iAreaId = 0;
};
Act2020AllStar.TopRankReq.prototype._clone = function () { return new Act2020AllStar.TopRankReq(); }
Act2020AllStar.TopRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.TopRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.TopRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
};

Act2020AllStar.TopRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
};

Act2020AllStar.TopRankRsp = function()
{
    this.tPanel = new Act2020AllStar.StageRankPanel();
    this.sDesc = "";
};
Act2020AllStar.TopRankRsp.prototype._clone = function () { return new Act2020AllStar.TopRankRsp(); }
Act2020AllStar.TopRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.TopRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.TopRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanel);
    os.writeString(1, this.sDesc);
};

Act2020AllStar.TopRankRsp.prototype.readFrom = function (is)
{
    this.tPanel= is.readStruct(0, false, this.tPanel);
    this.sDesc= is.readString(1, false, this.sDesc);
};

Act2020AllStar.HourRankReq = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
    this.lPid = 0;
};
Act2020AllStar.HourRankReq.prototype._clone = function () { return new Act2020AllStar.HourRankReq(); }
Act2020AllStar.HourRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HourRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HourRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
    os.writeInt64(2, this.lPid);
};

Act2020AllStar.HourRankReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
    this.lPid= is.readInt64(2, false, this.lPid);
};

Act2020AllStar.HourRankRsp = function()
{
    this.tPanel = new Act2020AllStar.StageRankPanel();
    this.tItem = new Act2020AllStar.RankItem();
};
Act2020AllStar.HourRankRsp.prototype._clone = function () { return new Act2020AllStar.HourRankRsp(); }
Act2020AllStar.HourRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HourRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HourRankRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPanel);
    os.writeStruct(1, this.tItem);
};

Act2020AllStar.HourRankRsp.prototype.readFrom = function (is)
{
    this.tPanel= is.readStruct(0, false, this.tPanel);
    this.tItem= is.readStruct(1, false, this.tItem);
};

Act2020AllStar.HourChampion = function()
{
    this.iHour = 0;
    this.tJump = new Act2020AllStar.JumpChannel();
    this.sNickName = "";
    this.sLogo = "";
};
Act2020AllStar.HourChampion.prototype._clone = function () { return new Act2020AllStar.HourChampion(); }
Act2020AllStar.HourChampion.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HourChampion.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HourChampion.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iHour);
    os.writeStruct(1, this.tJump);
    os.writeString(2, this.sNickName);
    os.writeString(3, this.sLogo);
};

Act2020AllStar.HourChampion.prototype.readFrom = function (is)
{
    this.iHour= is.readInt32(0, false, this.iHour);
    this.tJump= is.readStruct(1, false, this.tJump);
    this.sNickName= is.readString(2, false, this.sNickName);
    this.sLogo= is.readString(3, false, this.sLogo);
};

Act2020AllStar.HourChampionReq = function()
{
    this.iAreaId = 0;
    this.iSubAreaId = 0;
};
Act2020AllStar.HourChampionReq.prototype._clone = function () { return new Act2020AllStar.HourChampionReq(); }
Act2020AllStar.HourChampionReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HourChampionReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HourChampionReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAreaId);
    os.writeInt32(1, this.iSubAreaId);
};

Act2020AllStar.HourChampionReq.prototype.readFrom = function (is)
{
    this.iAreaId= is.readInt32(0, false, this.iAreaId);
    this.iSubAreaId= is.readInt32(1, false, this.iSubAreaId);
};

Act2020AllStar.HourChampionRsp = function()
{
    this.vChampions = new Taf.Vector(new Act2020AllStar.HourChampion());
};
Act2020AllStar.HourChampionRsp.prototype._clone = function () { return new Act2020AllStar.HourChampionRsp(); }
Act2020AllStar.HourChampionRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
Act2020AllStar.HourChampionRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

Act2020AllStar.HourChampionRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vChampions);
};

Act2020AllStar.HourChampionRsp.prototype.readFrom = function (is)
{
    this.vChampions= is.readVector(0, false, this.vChampions);
};


export default Act2020AllStar;

